(function () {
  'use strict';

  function initMojeS2bSection(configEl) {
    if (!configEl) return;

    function parseLastFrameUrl(url) {
      var clean = String(url || '').trim();
      if (!clean) return null;
      var queryIndex = clean.indexOf('?');
      var base = queryIndex >= 0 ? clean.slice(0, queryIndex) : clean;
      var query = queryIndex >= 0 ? clean.slice(queryIndex) : '';
      var match = base.match(/^(.*?)(\d+)(\.[a-zA-Z0-9]+)$/);
      if (!match) return null;
      return { prefix: match[1], count: parseInt(match[2], 10), pad: match[2].length, ext: match[3], query: query };
    }

    function buildFrameUrlList(parts) {
      var urls = [];
      var i;
      if (!parts || !parts.count) return urls;
      for (i = 1; i <= parts.count; i += 1) {
        urls.push(parts.prefix + String(i).padStart(parts.pad, '0') + parts.ext + parts.query);
      }
      return urls;
    }

    function frameUrlsFromRaw(raw) {
      var parsed = parseLastFrameUrl(raw);
      return parsed ? buildFrameUrlList(parsed) : [];
    }

    function withRequestedWidth(url, width) {
      return withRequestedSize(url, { width: width });
    }

    function withRequestedSize(url, opts) {
      opts = opts || {};
      try {
        var u = new URL(url, window.location.href);
        if (opts.width) u.searchParams.set('width', String(opts.width));
        else u.searchParams.delete('width');
        if (opts.height) u.searchParams.set('height', String(opts.height));
        else u.searchParams.delete('height');
        if (opts.crop) u.searchParams.set('crop', String(opts.crop));
        else u.searchParams.delete('crop');
        if (opts.crop === 'region') {
          u.searchParams.set('crop_left', String(opts.cropLeft || 0));
          u.searchParams.set('crop_top', String(opts.cropTop || 0));
          u.searchParams.set('crop_width', String(opts.cropWidth || 0));
          u.searchParams.set('crop_height', String(opts.cropHeight || 0));
        } else {
          u.searchParams.delete('crop_left');
          u.searchParams.delete('crop_top');
          u.searchParams.delete('crop_width');
          u.searchParams.delete('crop_height');
        }
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    var config = JSON.parse(configEl.textContent);
    var sectionId = config.sectionId;
    var root = document.getElementById('moje-s2b-' + sectionId);
    if (!root) return;

    var innerEl = root.querySelector('.moje-s2b__inner');
    var hazeBridgeEl = root.querySelector('.moje-s2b__haze-bridge');
    var introOverlayEl = root.querySelector('.moje-s2b__intro-overlay');
    var pinSpacer = root.querySelector('.moje-s2b__pin-spacer');
    var scrollHintEl = document.getElementById('moje-s2b-scroll-hint-' + sectionId);
    var scrollHintGone = false;
    var seqMouseEl = document.getElementById('moje-s2b-seq-mouse-' + sectionId);
    var canvas = document.getElementById('moje-s2b-canvas-' + sectionId);
    var loader = document.getElementById('moje-s2b-loader-' + sectionId);
    var loaderFill = document.getElementById('moje-s2b-loader-fill-' + sectionId);
    var loaderPct = document.getElementById('moje-s2b-loader-pct-' + sectionId);
    var pricingScene = document.getElementById('moje-s2b-pricing-' + sectionId);
    var pricingVideoLayer = document.getElementById('moje-s2b-pricing-video-layer-' + sectionId);
    var pricingVideo = document.getElementById('moje-s2b-pricing-video-' + sectionId);
    var pricingVideoMapEl = document.getElementById('moje-s2b-pricing-video-map-' + sectionId);
    var terraformDock = document.getElementById('moje-s2b-terraform-dock-' + sectionId);
    var pricingCarousel = document.getElementById('moje-s2b-pricing-cards-' + sectionId);
    var pricingCarouselWrap = document.getElementById('moje-s2b-pricing-carousel-wrap-' + sectionId);

    (function stylePricingSupportRows() {
      if (!pricingCarousel) return;
      var items = pricingCarousel.querySelectorAll('.moje-s2b__pricing-features li');
      var i;
      var text;
      for (i = 0; i < items.length; i += 1) {
        text = (items[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!text) {
          items[i].hidden = true;
          continue;
        }
        items[i].classList.remove('moje-s2b__feature-support--none', 'moje-s2b__feature-support--ok');
        if (text.indexOf('žádná podpora') !== -1) {
          items[i].classList.add('moje-s2b__feature-support--none');
        } else if (text.indexOf('podpora') !== -1) {
          items[i].classList.add('moje-s2b__feature-support--ok');
        }
      }
    })();
    var pricingTouchOverlay = document.getElementById('moje-s2b-pricing-touch-' + sectionId);
    var bufferEl = document.getElementById('moje-s2b-buffer-' + sectionId);
    var bufferMistEl = document.getElementById('moje-s2b-buffer-mist-' + sectionId);

    var ctx = canvas ? canvas.getContext('2d', { alpha: true }) : null;
    var webmPlaybackSupported = (function () {
      try {
        var probe = document.createElement('video');
        if (!probe || typeof probe.canPlayType !== 'function') return false;
        return !!(
          probe.canPlayType('video/webm; codecs="vp9"') ||
          probe.canPlayType('video/webm; codecs="vp8"') ||
          probe.canPlayType('video/webm')
        );
      } catch (eWebmProbe) {
        return false;
      }
    })();

    function sanitizeVideoCatalogEntry(entry) {
      if (!entry) return entry;
      if (!webmPlaybackSupported && entry.webm) entry.webm = '';
      return entry;
    }

    var MOBILE_MAX = 989;
    var INTRO_FADE_LAST_FRAME_DEFAULT = 17;
    /* Mobil: černý rozpad odshora na snímcích 1–24, na 25. (index 24) už nic. */
    var MOBILE_TOP_DECAY_GONE_INDEX = 24;
    var MOBILE_TOP_DECAY_MAX_RATIO = 0.22;
    function isMobileViewport() {
      return window.innerWidth <= MOBILE_MAX;
    }

    /* Široká média (PC 16:9): desktop, nebo mobil otočený na šířku.
       Videa, sekvence i rozložení karet (bez karuselu). Těžké PC efekty karet ne.

       Detekce orientace je striktní: screen.orientation (fyzická orientace zařízení, klávesnice
       ji nemění) → fallback matchMedia('(orientation: landscape)'). Dřívější porovnání
       innerWidth > innerHeight přepnulo na PC pack (40+ MB) při otevření klávesnice na Androidu. */
    var landscapeMq = null;
    var coarseTouchMq = null;
    try {
      landscapeMq = window.matchMedia ? window.matchMedia('(orientation: landscape)') : null;
      coarseTouchMq = window.matchMedia ? window.matchMedia('(hover: none) and (pointer: coarse)') : null;
    } catch (eLandMq) {
      landscapeMq = null;
      coarseTouchMq = null;
    }
    function deviceIsLandscape() {
      /* Dotykové zařízení: fyzická orientace (Android klávesnice viewport zmenší, ale telefon neotočí). */
      if (coarseTouchMq && coarseTouchMq.matches) {
        try {
          var so = window.screen && window.screen.orientation;
          if (so && typeof so.type === 'string' && so.type) {
            return so.type.indexOf('landscape') === 0;
          }
        } catch (eSo) {}
      }
      /* PC s úzkým oknem / starší prohlížeče: orientace viewportu. */
      return !!(landscapeMq && landscapeMq.matches);
    }
    function useWideMediaAssets() {
      if ((window.innerWidth || 0) > MOBILE_MAX) return true;
      return deviceIsLandscape();
    }

    function useDesktopSequenceAssets() {
      return useWideMediaAssets();
    }

    function useMobileMediaAssets() {
      return !useWideMediaAssets();
    }

    function syncWideMediaClass() {
      if (!root) return;
      var wide = useWideMediaAssets();
      root.classList.toggle('moje-s2b--wide-media', wide);
      if (wide && pricingCarousel) {
        try { pricingCarousel.scrollLeft = 0; } catch (eSl) {}
      }
    }

    var sequenceByStage = config.sequences || {};
    function sequencePack(stage) {
      var id = stage === 1 || stage === 3 ? String(stage) : '2';
      return sequenceByStage[id] || sequenceByStage[stage] || {};
    }
    function wantMobilePack(packHint) {
      if (packHint === 'd' || packHint === 'desktop') return false;
      if (packHint === 'm' || packHint === 'mobile') return true;
      return useMobileMediaAssets();
    }

    function sequenceUrlsFor(stage, packHint) {
      var pack = sequencePack(stage);
      var desktop = frameUrlsFromRaw(pack.lastFrameUrl || (stage === 2 || stage === '2' ? config.lastFrameUrl : ''));
      var mobile = frameUrlsFromRaw(pack.lastFrameUrlMobile || (stage === 2 || stage === '2' ? config.lastFrameUrlMobile : ''));
      if (wantMobilePack(packHint) && mobile.length) return mobile;
      if (desktop.length) return desktop;
      if (String(stage) !== '2') return sequenceUrlsFor(2, packHint);
      return desktop;
    }
    function resolveSequenceStage(stage) {
      var id = stage === 1 || stage === 3 ? stage : 2;
      if (sequenceUrlsFor(id).length) return id;
      return 2;
    }

    var sequenceStore = {};
    var activeSequenceStage = 2;
    var sequenceLoadSilent = false;
    var sequenceSwitchReady = false;
    var sequenceLoadFromEnd = false;
    var sequenceLayoutFrozen = false;
    var seqLoadQueue = [];
    var seqLoadInFlight = 0;
    var seqLoadPumping = false;
    var seqLoadPumpTimer = 0;

    function activeFrameUrls() {
      return sequenceUrlsFor(activeSequenceStage);
    }

    var frameUrls = activeFrameUrls();
    var images = [];
    var totalFrames = frameUrls.length;
    var maxFrameIndex = Math.max(0, totalFrames - 1);
    var loadedCount = 0;
    var currentFrameIndex = 0;
    var lastDrawnIndex = -1;
    var viewportW = 0;
    var viewportH = 0;
    var canvasCssW = 0;
    var canvasCssH = 0;
    var pinStartY = 0;
    var pinStartCached = false;
    var sequencePx = 0;
    var bufferPx = 0;
    var pricingPx = 0;
    var lastAppliedMinHeightPx = '';
    var lastAppliedTravelPx = 0;
    var lastAppliedHazePx = 0;
    var lastAppliedVhPx = '';
    var lastViewportWForMetrics = -1;
    var ignoreMetricsUntil = 0;
    var autoplayConsumed = false;
    var autoplayPlaying = false;
    var pendingAutoplayFromNav = false;
    var pendingAutoplayWatchRaf = 0;
    var pendingAutoplayScrollEnded = false;
    var pendingAutoplaySettledFrames = 0;
    var chromeLockMode = '';
    var terraformLockY = 0;
    var programmaticNavUntil = 0;
    var programmaticNavTimer = 0;
    var programmaticTargetY = NaN;
    var journey = 'pre';
    var atPricing = false;
    var belowArmed = false;
    var lastScrollYForDir = 0;
    var pricingFlingVelInited = false;
    var pricingScrollVelPxMs = 0;
    var pricingFlingVelTs = 0;
    var pricingFlingArmed = true;
    var pricingFlingStopActive = false;
    var pricingFlingFrozen = false;
    var pricingFlingLockY = null;
    var pricingFlingHoldUntil = 0;
    var pricingFlingReleaseTimer = 0;
    var pricingFlingSafetyTimer = 0;
    var pricingFlingFreezeRaf = 0;
    var pricingFlingTouchActive = false;
    var pricingFlingPrevHtmlOverflow = '';
    var pricingFlingPrevBodyOverflow = '';
    var pricingFlingPrevHtmlOverscroll = '';
    var pricingFlingPrevBodyOverscroll = '';
    var PRICING_FLING_VEL_PX_MS = 1.25;
    var PRICING_FLING_JUMP_PX = 110;
    var PRICING_FLING_HOLD_MS = 100;
    var pricingSettleUntil = 0;
    var sequenceEnterUntil = 0;
    var autoplayRaf = 0;
    var autoplayLastTs = 0;
    var autoplayFrameAcc = 0;
    var autoplayLockY = 0;
    var pricingVisible = false;
    var pricingLocked = false;
    var pricingExiting = false;
    var pricingFadeGen = 0;
    var pricingCardsExitSceneTimer = 0;
    var pricingSeqRestoreTimer = 0;
    var pricingFadeCooldownUntil = 0;
    var pricingFadeRetryTimer = 0;
    var suppressPricingRelockUntil = 0;
    var pricingTouchY = null;
    var currentPricingStage = 2;
    var sessionResumeApi = window.mojeSessionResume;
    var sessionResumeS2b =
      sessionResumeApi && typeof sessionResumeApi.getS2b === 'function'
        ? sessionResumeApi.getS2b()
        : null;
    if (window.__mojeColdStart) sessionResumeS2b = null;
    if (
      sessionResumeS2b &&
      typeof sessionResumeS2b === 'object' &&
      sessionResumeApi &&
      (sessionResumeApi.active || sessionResumeApi.restoring)
    ) {
      if (
        sessionResumeS2b.autoplayConsumed ||
        sessionResumeS2b.autoplayPlaying ||
        sessionResumeS2b.pricingLocked ||
        sessionResumeS2b.journey === 'autoplay' ||
        sessionResumeS2b.journey === 'sequence' ||
        sessionResumeS2b.journey === 'buffer' ||
        sessionResumeS2b.journey === 'pricing' ||
        sessionResumeS2b.journey === 'below'
      ) {
        autoplayConsumed = true;
      }
      if (sessionResumeS2b.pricingStage >= 1 && sessionResumeS2b.pricingStage <= 3) {
        currentPricingStage = sessionResumeS2b.pricingStage;
        activeSequenceStage = resolveSequenceStage(currentPricingStage);
      }
      if (Number.isFinite(sessionResumeS2b.frameIndex)) {
        currentFrameIndex = Math.max(0, Math.min(maxFrameIndex, sessionResumeS2b.frameIndex | 0));
      }
    }
    var pricingCarouselScrollBound = false;
    var pricingFeaturesExpandBound = false;
    var pricingZoneTouchStartX = null;
    var pricingZoneTouchStartY = null;
    var pricingZoneTouchLastX = null;
    var pricingZoneTouchLastY = null;
    var pricingZoneTouchAxis = null;
    var pricingZoneTapCardStage = null;
    var pricingZoneTapExpandBtn = null;
    var pricingZoneTapHintDir = null;
    var pricingZoneDragStartStage = null;
    var PRICING_ZONE_TOUCH_THRESHOLD = 8;
    var PRICING_ZONE_TAP_SLOP = 14;
    var PRICING_CAROUSEL_SWIPE_ADVANCE_RATIO = 0.12;
    var PRICING_CAROUSEL_FLICK_RATIO = 0.05;
    var PRICING_CAROUSEL_FLICK_VEL = 0.42;
    var PRICING_CAROUSEL_DRAG_GAIN = 0.62;
    var pricingCarouselSnapSettleTimer = null;
    var pricingCarouselScrollAnimRaf = null;
    var pricingCarouselPreviewRaf = null;
    var pricingCarouselTouchVelocityPxMs = 0;
    var pricingCarouselTouchLastTs = 0;
    var pricingCarouselCentersCache = null;
    var pricingCarouselCentersCacheW = 0;
    var pricingCarouselDragPendingDx = 0;
    var pricingCarouselDragRaf = 0;
    var pricingCarouselProgrammaticScroll = false;
    var lastPricingCarouselPreviewStage = null;
    var pricingBgPanCurrent = 0;
    var pricingBgPanTarget = 0;
    var pricingBgPanAnimRaf = null;
    var pricingBgPanLocked = false;
    var pricingBgPanLockedValue = 0;
    var PRICING_BG_PAN_LERP = 0.07;
    var PRICING_BG_PAN_FRACTION = 0.52;
    var pricingMediaAspect = useWideMediaAssets() ? 16 / 9 : 9 / 16;
    var pricingTransitioning = false;
    var pricingTransitionFinishLock = false;
    var pricingTransitionFailTimer = 0;
    var pricingVideoEndWatchRaf = 0;
    var pricingDestCoverTimer = 0;
    var detachPricingVideoReadyListeners = function () {};
    var PRICING_VIDEO_FREEZE_TAIL_S = 0.05;
    var PRICING_CARDS_EXIT_MIN_MS = 280;
    var PRICING_CARDS_EXIT_FADE_MS = 2000;
    var PRICING_CARDS_RESTORE_MS = 450;
    var rafScheduled = false;
    var mobileFixedPin = false;
    /* Fixed pin jen z autoplay/sekvence. Zespodu nechat sticky, ať karty neposkočí. */
    var pricingUseFixedPin = false;

    var autoplayFps = Number(config.autoplayFps);
    if (!Number.isFinite(autoplayFps)) autoplayFps = 24;
    autoplayFps = Math.max(8, Math.min(60, autoplayFps));
    /*
     * Streamované načítání (runway buffering): autoplay startuje po AUTOPLAY_RUNWAY_FRAMES
     * souvisle načtených snímcích od začátku, zbytek se dočítá během přehrávání. Když přehrávání
     * dojede načtená data, drží se poslední snímek a pokračuje po doplnění AUTOPLAY_REBUFFER_FRAMES
     * (po blocích, ne trhaně snímek po snímku).
     */
    var AUTOPLAY_RUNWAY_FRAMES = Number(config.autoplayRunwayFrames);
    if (!Number.isFinite(AUTOPLAY_RUNWAY_FRAMES)) AUTOPLAY_RUNWAY_FRAMES = 18;
    AUTOPLAY_RUNWAY_FRAMES = Math.max(8, Math.min(60, Math.round(AUTOPLAY_RUNWAY_FRAMES)));
    var AUTOPLAY_REBUFFER_FRAMES = 6;
    var AUTOPLAY_REBUFFER_GIVEUP_MS = 6000;
    var autoplayRebufferUntil = -1;
    var autoplayRebufferSince = 0;
    var autoplayWaitingForRunway = false;
    /*
     * Dekódovací okno kolem aktuálního snímku – jen HINT přes img.decode():
     *   - asynchronní, mimo hlavní vlákno (Chromium: cc decode cache, WebKit: purgeable);
     *   - prohlížeč drží dekódovaná data v limitované, uvolnitelné cache → žádný jetsam na iOS,
     *     žádné vlastní ImageBitmapy (createImageBitmap(<img>) je v Chromiu synchronní na hlavním
     *     vlákně → sekání při scrubu; asynchronní je jen z Blobu).
     * Okno je směrové: víc snímků ve směru pohybu (autoplay / scroll), pár zpět.
     * Nikdy se nedekóduje celá sekvence najednou (185 × 8 MB RGBA).
     *
     * Chromium: img.decode() plní cache kompozitoru, ne cache 2D canvasu (drawImage dekóduje sám
     * a drží LRU cache ve sdíleném GPU kontextu) → hint tam nepomůže a jen zaměstnává raster
     * workery během scrollu. Hinty proto jen WebKit/Firefox, kde je dekódovaná bitmapa sdílená.
     */
    var DECODE_HINTS_ENABLED = (function () {
      var ua = navigator.userAgent || '';
      if (/iP(hone|ad|od)/.test(ua)) return true;
      if (typeof window.chrome === 'object' && window.chrome) return false;
      return !/Chrome|Chromium|Edg\/|OPR\//.test(ua);
    })();
    var DECODE_AHEAD = isMobileViewport() ? 12 : 24;
    var DECODE_BEHIND = 6;
    var DECODE_REPRIME_MS = 1500;
    var decodeWindowLo = -1;
    var decodeWindowHi = -1;
    var decodeWindowCenter = -1;
    var decodeWindowDir = 1;
    var decodeStoreRef = null;
    var sequenceScrollVh = Number(config.sequenceScrollVh);
    if (!Number.isFinite(sequenceScrollVh)) sequenceScrollVh = 4;
    sequenceScrollVh = Math.max(1, Math.min(14, sequenceScrollVh));
    var bufferVh = Number(config.bufferVh);
    if (!Number.isFinite(bufferVh)) bufferVh = 50;
    bufferVh = Math.max(20, Math.min(80, bufferVh));
    var BUFFER_DEAD_PCT = 0.25;
    var dockAnchorTimer = 0;
    var dockAnchorDir = 0;
    var lastDockAnchorY = 0;
    var dockSnapLockUntil = 0;

    function sanitizeVideoMapGroup(group) {
      var out = {};
      if (!group || typeof group !== 'object') return out;
      Object.keys(group).forEach(function (key) {
        if (key === 'desktop' || key === 'mobile') return;
        out[key] = sanitizeVideoCatalogEntry(group[key] || {});
      });
      return out;
    }

    var pricingVideoMap = { desktop: {}, mobile: {} };
    try {
      var rawVideoMap = pricingVideoMapEl ? JSON.parse(pricingVideoMapEl.textContent) : {};
      if (rawVideoMap.desktop || rawVideoMap.mobile) {
        pricingVideoMap = {
          desktop: sanitizeVideoMapGroup(rawVideoMap.desktop),
          mobile: sanitizeVideoMapGroup(rawVideoMap.mobile)
        };
      } else {
        pricingVideoMap = {
          desktop: sanitizeVideoMapGroup(rawVideoMap),
          mobile: {}
        };
      }
    } catch (eMap) {
      pricingVideoMap = { desktop: {}, mobile: {} };
    }
    var TERRAFORM_KEYS = ['1-2', '1-3', '2-1', '2-3', '3-1', '3-2'];
    var terraformVideos = {};
    var terraformPreloadStarted = false;
    var terraformNudgeArmed = false;
    var mediaPackSyncTimer = 0;
    var lastMediaPackId = useWideMediaAssets() ? 'd' : 'm';
    var terraformWarmQueue = [];
    var terraformWarming = false;
    var terraformWarmed = {};
    var terraformWarmQueued = {};

    function getViewportH() {
      if (typeof window.mojeGetStableViewportHeight === 'function') {
        var stable = window.mojeGetStableViewportHeight();
        if (stable > 120) return stable;
      }
      var cssPx = 0;
      try {
        var raw = getComputedStyle(document.documentElement).getPropertyValue('--moje-vh-px').trim();
        if (raw && raw.indexOf('px') !== -1) cssPx = parseFloat(raw);
      } catch (eVh) {}
      if (cssPx > 120) return cssPx;
      return window.innerHeight || 800;
    }

    function getScrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function setScrollY(y) {
      var target = Math.max(0, y);
      var html = document.documentElement;
      var prevHtml = html.style.scrollBehavior;
      var prevBody = document.body ? document.body.style.scrollBehavior : '';
      html.style.scrollBehavior = 'auto';
      if (document.body) document.body.style.scrollBehavior = 'auto';
      if (typeof window.scrollTo === 'function') {
        try {
          window.scrollTo({ top: target, left: 0, behavior: 'instant' });
        } catch (eInstant) {
          window.scrollTo(0, target);
        }
      }
      html.style.scrollBehavior = prevHtml;
      if (document.body) document.body.style.scrollBehavior = prevBody;
    }

    function sequenceEndY() {
      return pinStartY + Math.max(0, sequencePx);
    }

    function bufferStartY() {
      return sequenceEndY();
    }

    function pricingDockY() {
      return bufferStartY() + Math.max(0, bufferPx);
    }

    function pricingSnapY() {
      return pricingDockY();
    }

    function travelFor() {
      return sequencePx + bufferPx;
    }

    function journeyTravelPx() {
      return travelFor(journey);
    }

    function measureHazeHeight() {
      if (!hazeBridgeEl || !useDesktopSequenceAssets()) return 0;
      var h = hazeBridgeEl.getBoundingClientRect().height;
      if (!Number.isFinite(h) || h < 1) return 0;
      return Math.round(h);
    }

    function introImageEl() {
      var sel = 'img[data-s2b-seq-phase="' + activeSequenceStage + '"]';
      if (introOverlayEl) {
        var overlayImg = introOverlayEl.querySelector(sel) || introOverlayEl.querySelector('img.is-active');
        if (overlayImg) return overlayImg;
      }
      if (hazeBridgeEl) {
        return hazeBridgeEl.querySelector(sel) || hazeBridgeEl.querySelector('img.is-active');
      }
      return null;
    }

    function sequenceCoverScale(seqW, seqH, cw, ch) {
      if (!(seqW > 0) || !(seqH > 0) || cw < 2 || ch < 2) return 0;
      return Math.max(cw / seqW, ch / seqH);
    }

    function sequenceRefImage() {
      if (images[0] && images[0].naturalWidth) return images[0];
      if (images[currentFrameIndex] && images[currentFrameIndex].naturalWidth) {
        return images[currentFrameIndex];
      }
      var i;
      for (i = images.length - 1; i >= 0; i -= 1) {
        if (images[i] && images[i].naturalWidth) return images[i];
      }
      return null;
    }

    function syncIntroLayout() {
      if (sequenceLayoutFrozen) return;
      var maskImg = introImageEl();
      var seqImg = sequenceRefImage();
      var extra = 0;
      var cw = canvasCssW || (innerEl && innerEl.clientWidth) || viewportW || 0;
      var ch = canvasCssH || viewportH || (innerEl && innerEl.clientHeight) || 0;

      function resetIntroBox() {
        root.style.setProperty('--moje-s2b-intro-extra-px', '0px');
        if (hazeBridgeEl) hazeBridgeEl.style.height = '0px';
      }

      if (!useDesktopSequenceAssets()) {
        resetIntroBox();
        return;
      }
      if (!maskImg || !maskImg.naturalWidth || cw < 2 || ch < 2) {
        return;
      }

      var srcW = Number(maskImg.getAttribute('data-s2b-haze-w')) || maskImg.naturalWidth;
      var srcH = Number(maskImg.getAttribute('data-s2b-haze-h')) || maskImg.naturalHeight;
      if (!(srcW > 1) || !(srcH > 1)) {
        srcW = maskImg.naturalWidth;
        srcH = maskImg.naturalHeight;
      }

      var seqW = 0;
      var seqH = 0;
      if (seqImg && seqImg.naturalWidth && (seqImg.naturalWidth / seqImg.naturalHeight) > 1.2) {
        seqW = seqImg.naturalWidth;
        seqH = seqImg.naturalHeight;
      } else {
        seqW = srcW;
        seqH = srcW * 9 / 16;
      }
      var scale = sequenceCoverScale(seqW, seqH, cw, ch);
      if (!(scale > 0)) {
        resetIntroBox();
        return;
      }

      var pxPerMask = scale * (seqW / srcW);
      var displayW = srcW * pxPerMask;
      var displayH = srcH * pxPerMask;
      var seqDh = seqH * scale;
      extra = Math.max(0, Math.round(displayH - seqDh));
      var left = Math.round((cw - displayW) * 0.5);
      var srcAspect = srcW / srcH;
      var natAspect = maskImg.naturalWidth / maskImg.naturalHeight;
      var placeAsStrip = srcAspect > 0 && natAspect < srcAspect * 0.85;

      function place(wrap, topPx) {
        if (!wrap) return;
        var el = wrap.querySelector('img[data-s2b-seq-phase="' + activeSequenceStage + '"]') ||
          wrap.querySelector('img.is-active');
        if (!el) return;
        el.style.position = 'absolute';
        el.style.right = 'auto';
        el.style.bottom = 'auto';
        el.style.top = Math.round(topPx) + 'px';
        el.style.maxWidth = 'none';
        el.style.height = Math.round(displayH) + 'px';
        if (placeAsStrip) {
          el.style.left = '0px';
          el.style.width = Math.round(cw) + 'px';
        } else {
          el.style.left = left + 'px';
          el.style.width = Math.round(displayW) + 'px';
        }
      }

      root.style.setProperty('--moje-s2b-intro-extra-px', extra + 'px');
      if (hazeBridgeEl) {
        hazeBridgeEl.style.height = extra + 'px';
        place(hazeBridgeEl, 0);
      }
      if (introOverlayEl) place(introOverlayEl, -extra);
    }

    function introFadeLastFrame(stage) {
      var pack = sequencePack(stage == null ? activeSequenceStage : stage);
      var n = Number(pack && pack.introFadeFrame);
      if (!Number.isFinite(n)) n = INTRO_FADE_LAST_FRAME_DEFAULT;
      n = Math.max(2, Math.min(100, Math.round(n)));
      if (totalFrames > 1) n = Math.min(n, totalFrames);
      return n;
    }

    function syncIntroFade(frameIndex) {
      var lastFrame = introFadeLastFrame();
      var i = (frameIndex | 0) + 1;
      var op = 1;
      if (i >= lastFrame) op = 0;
      else if (i > 1 && lastFrame > 1) op = 1 - (i - 1) / (lastFrame - 1);
      if (introOverlayEl) {
        introOverlayEl.style.opacity = String(op);
        introOverlayEl.style.visibility = op > 0.001 ? 'visible' : 'hidden';
      }
      if (hazeBridgeEl) hazeBridgeEl.style.opacity = String(op);
    }

    function measurePinStart() {
      if (!root) return 0;
      var rect = root.getBoundingClientRect();
      return getScrollY() + rect.top + measureHazeHeight();
    }

    function refreshPinStart(force) {
      if (!force && pinStartCached && pinStartY > 0) return;
      pinStartY = measurePinStart();
      pinStartCached = pinStartY > 0 || getScrollY() < 2;
    }

    function applySectionHeight(opts) {
      opts = opts || {};
      if (sequenceLayoutFrozen && !opts.force) return;
      var nextTravel = journeyTravelPx();
      var hazePx = measureHazeHeight();
      var minHeightPx = Math.max(1, Math.round(hazePx + viewportH + nextTravel)) + 'px';
      var prevTravel = lastAppliedTravelPx;
      var prevHaze = lastAppliedHazePx;
      var y = getScrollY();
      if (lastAppliedMinHeightPx !== minHeightPx) {
        lastAppliedMinHeightPx = minHeightPx;
        lastAppliedTravelPx = nextTravel;
        lastAppliedHazePx = hazePx;
        root.style.minHeight = minHeightPx;
        /*
         * Sekvence nahoře zvětšuje/zmenšuje dokument pod pinStartY.
         * Kompenzuj scrollY, ať karta/následující obsah vizuálně neskočí.
         */
        if (opts.compensate !== false && pinStartCached && y >= pinStartY - 2) {
          var delta = (nextTravel - prevTravel) + (hazePx - prevHaze);
          if (Math.abs(delta) > 1) setScrollY(y + delta);
        }
      } else {
        lastAppliedTravelPx = nextTravel;
        lastAppliedHazePx = hazePx;
      }
    }

    function syncInnerBoxToRoot(opts) {
      if (!innerEl || !root) return;
      opts = opts || {};
      if (mobileFixedPin) {
        innerEl.style.top = '0px';
        innerEl.style.left = '0px';
      } else {
        innerEl.style.top = '';
        innerEl.style.left = '';
      }
      var keepPinnedWidth = Date.now() < ignoreMetricsUntil ||
        ((journey === 'pricing' || journey === 'below') && !opts.force && innerEl.style.width);
      if (keepPinnedWidth) return;
      var rect = root.getBoundingClientRect();
      var w = Math.round(rect.width);
      if (w < 1) return;
      innerEl.style.width = w + 'px';
      innerEl.style.maxWidth = w + 'px';
    }

    function updateMetrics(options) {
      var opts = options || {};
      viewportW = window.innerWidth || 0;
      var nextH = getViewportH();
      var frozenPx = lastAppliedVhPx ? parseFloat(lastAppliedVhPx) : 0;
      var widthJump = lastViewportWForMetrics < 0 || Math.abs(viewportW - lastViewportWForMetrics) > 24;
      lastViewportWForMetrics = viewportW;
      var heightJump = frozenPx > 120 && Math.abs(nextH - frozenPx) > 48;
      var inPinToggle = Date.now() < ignoreMetricsUntil;
      var inPricingScene = journey === 'pricing' || journey === 'below';
      var inPinnedJourney = journey === 'sequence' || journey === 'autoplay' || journey === 'buffer' || inPricingScene;
      var freezeVh = inPinToggle || (inPinnedJourney && !opts.force && !widthJump && !heightJump);
      if (freezeVh && frozenPx > 120) nextH = frozenPx;
      viewportH = nextH;
      sequencePx = sequenceScrollVh * viewportH;
      bufferPx = (bufferVh / 100) * viewportH;
      pricingPx = 0;
      var vhPx = Math.round(viewportH) + 'px';
      if (lastAppliedVhPx !== vhPx) {
        lastAppliedVhPx = vhPx;
        root.style.setProperty('--moje-s2b-vh-px', vhPx);
      }
      root.style.setProperty('--moje-s2b-buffer-px', Math.round(bufferPx) + 'px');
      syncIntroLayout();
      applySectionHeight();
      if (pinSpacer) {
        pinSpacer.style.display = 'none';
        pinSpacer.style.height = '0px';
      }
      syncInnerBoxToRoot({
        force: !!opts.force && Date.now() >= ignoreMetricsUntil
      });
      if (opts.refreshPinStart) refreshPinStart(true);
    }

    function isSlowNetwork() {
      try {
        var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!conn) return false;
        if (conn.saveData) return true;
        var t = String(conn.effectiveType || '').toLowerCase();
        if (t === 'slow-2g' || t === '2g' || t === '3g') return true;
        if (typeof conn.downlink === 'number' && conn.downlink > 0 && conn.downlink < 1.5) return true;
      } catch (eSlow) {}
      return false;
    }

    function getOptimalFrameWidth() {
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var cw = viewportW || window.innerWidth || 1920;
      var ch = viewportH || window.innerHeight || 1080;
      var slow = isSlowNetwork();
      if (useMobileMediaAssets()) {
        return Math.max(720, Math.min(slow ? 960 : 1440, Math.ceil(cw * dpr)));
      }
      return Math.max(720, Math.min(slow ? 1280 : 1920, Math.ceil(Math.max(cw, ch * 1.78) * dpr)));
    }

    function getSequenceImageUrl(url) {
      return withRequestedWidth(url, getOptimalFrameWidth());
    }

    function unloadImageSrc(img) {
      if (!img) return;
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      try { img.removeAttribute('srcset'); } catch (eSrcset) {}
    }

    function assignLazyImageSrc(img) {
      if (!img) return;
      var ds = img.getAttribute('data-src');
      var dss = img.getAttribute('data-srcset');
      if (dss && img.getAttribute('srcset') !== dss) img.setAttribute('srcset', dss);
      if (ds && img.getAttribute('src') !== ds) img.src = ds;
    }

    function stageWrapHasMobileImage(wrap) {
      return !!(wrap && wrap.querySelector('.moje-s2b__pricing-stage-img--mobile[data-src], .moje-s2b__pricing-stage-img--mobile[src]'));
    }

    /*
     * Kdy držet "extra" DOM obrázky (pozadí ceníku, haze ostatních fází) mimo síť:
     *   - před rozjezdem autoplaye (runway snímků má přednost),
     *   - při čekání na autoplay z navigace.
     * Jakmile autoplay běží nebo doběhl, pásmo už není kritické – dřív se čekalo na 100 % snímků,
     * což by po zavedení streamovaného bufferingu nechalo ceník bez pozadí.
     */
    function sequenceHoldsExtraMedia() {
      if (pendingAutoplayFromNav) return true;
      if (defaultSequenceFullyReady()) return false;
      return !autoplayPlaying && !autoplayConsumed;
    }

    /* Během autoplaye jen pozadí aktivní karty (bude potřeba na konci), ostatní až po něm. */
    function sequenceWantsActiveStageOnly() {
      return autoplayPlaying && !autoplayConsumed && !defaultSequenceFullyReady();
    }

    function hydrateStageImagesForViewport() {
      if (!root) return;
      var mobile = useMobileMediaAssets();
      var holdExtra = sequenceHoldsExtraMedia();
      var activeOnly = sequenceWantsActiveStageOnly();
      var imgs = root.querySelectorAll('.moje-s2b__pricing-stage-img');
      var i;
      for (i = 0; i < imgs.length; i += 1) {
        var img = imgs[i];
        var isMob = img.classList.contains('moje-s2b__pricing-stage-img--mobile');
        var isDesk = img.classList.contains('moje-s2b__pricing-stage-img--desktop');
        var wrap = img.closest('[data-s3-stage-bg]');
        var wanted = (mobile && isMob) || (!mobile && isDesk);
        if (mobile && isDesk && !stageWrapHasMobileImage(wrap)) wanted = true;
        if (holdExtra) continue;
        if (activeOnly && wrap && !wrap.classList.contains('moje-s2b__pricing-stage-bg--active')) continue;
        if (wanted) assignLazyImageSrc(img);
        else unloadImageSrc(img);
      }
    }

    function applyAdaptiveDomImages() {
      var nodes = root.querySelectorAll('[data-s2b-crop-src]');
      var i;
      var img;
      var master;
      var kind;
      var next;
      var phase;
      var desktopIntro = useDesktopSequenceAssets();
      var holdExtra = sequenceHoldsExtraMedia();
      var activePhase = String(activeSequenceStage);
      for (i = 0; i < nodes.length; i += 1) {
        img = nodes[i];
        master = img.getAttribute('data-s2b-crop-src');
        if (!master) continue;
        kind = img.getAttribute('data-s2b-crop-kind') || '';
        if (kind === 'intro' && !desktopIntro) {
          unloadImageSrc(img);
          continue;
        }
        phase = img.getAttribute('data-s2b-seq-phase');
        if (holdExtra && kind === 'intro' && phase && phase !== activePhase) continue;
        next = withRequestedWidth(master, getOptimalFrameWidth());
        if (img.getAttribute('src') === next) continue;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = next;
      }
      hydrateStageImagesForViewport();
    }

    /* Backing store max 2× (snímky se stahují taky max 2×): DPR 3 na iPhonu = 11,8 MB canvas
       a drawImage upscaloval 2× data na 3× plátno bez zisku. */
    function canvasDpr() {
      return Math.min(2, window.devicePixelRatio || 1);
    }

    function resizeCanvas() {
      if (!canvas || !ctx) return;
      var dpr = canvasDpr();
      var w = innerEl ? innerEl.clientWidth : viewportW || window.innerWidth;
      var h = innerEl ? innerEl.clientHeight : viewportH || window.innerHeight;
      if (canvasCssW > 0 && canvasCssH > 0 && Math.abs(w - canvasCssW) < 2 && Math.abs(h - canvasCssH) < 2) {
        return;
      }
      canvasCssW = w;
      canvasCssH = h;
      var bw = Math.max(1, Math.round(w * dpr));
      var bh = Math.max(1, Math.round(h * dpr));
      if (canvas.width !== bw || canvas.height !== bh) {
        canvas.width = bw;
        canvas.height = bh;
        canvas.style.width = Math.round(w) + 'px';
        canvas.style.height = Math.round(h) + 'px';
        lastDrawnIndex = -1;
      }
    }

    /* PC: cover + top (ořezává se spodek). Mobil: vždy celá výška snímku, strany se ořezávají
       nebo zůstanou volné — stejné zarovnání jako pozadí cenových karet, ať poslední snímek naváže. */
    /* Kreslí se vždy přímo z <img>; dekódovaná data spravuje cache prohlížeče (viz decode okno). */
    function drawCover(img) {
      if (!ctx || !img || !img.complete || !img.naturalWidth) return;
      resizeCanvas();
      var dpr = canvasDpr();
      var cw = canvasCssW || (canvas.width / dpr);
      var ch = canvasCssH || (canvas.height / dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var iw = img.naturalWidth;
      var ih = img.naturalHeight;
      var scale = useWideMediaAssets() || iw >= ih ? Math.max(cw / iw, ch / ih) : (ch / ih);
      if (!(scale > 0)) return;
      var dw = iw * scale;
      var dh = ih * scale;
      var dx = (cw - dw) * 0.5;
      var dy = 0;
      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(img, 0, 0, iw, ih, dx, dy, dw, dh);
    }

    /* —— Směrové dekódovací okno (aktivní sekvence) —— */
    function resetDecodeWindow() {
      decodeWindowLo = -1;
      decodeWindowHi = -1;
      decodeWindowCenter = -1;
    }

    /* Asynchronní decode hint; opakuje se nejdřív po DECODE_REPRIME_MS (cache mohla snímek uvolnit). */
    function primeDecodedFrame(img, now) {
      if (!DECODE_HINTS_ENABLED) return;
      if (!img || typeof img.decode !== 'function' || !img.complete || !img.naturalWidth) return;
      var t = now || Date.now();
      if (img.__s2bPrimedAt && t - img.__s2bPrimedAt < DECODE_REPRIME_MS) return;
      img.__s2bPrimedAt = t;
      try {
        img.decode().catch(function () {});
      } catch (eDecode) {}
    }

    /* Snímek dorazil ze sítě: dekódovat jen když je v okně (ostatní až když se k nim scrub přiblíží). */
    function primeFrameIfInWindow(index) {
      if (index < decodeWindowLo || index > decodeWindowHi) return;
      primeDecodedFrame(images[index]);
    }

    function syncDecodeWindow(center, force) {
      if (!totalFrames) return;
      if (decodeStoreRef !== images) {
        resetDecodeWindow();
        decodeStoreRef = images;
      }
      var c = Math.max(0, Math.min(maxFrameIndex, center | 0));
      if (decodeWindowCenter >= 0 && c !== decodeWindowCenter) decodeWindowDir = c > decodeWindowCenter ? 1 : -1;
      if (!force && decodeWindowCenter >= 0 && Math.abs(c - decodeWindowCenter) < 2) return;
      decodeWindowCenter = c;
      var ahead = DECODE_AHEAD;
      var behind = DECODE_BEHIND;
      var lo = Math.max(0, c - (decodeWindowDir > 0 ? behind : ahead));
      var hi = Math.min(maxFrameIndex, c + (decodeWindowDir > 0 ? ahead : behind));
      decodeWindowLo = lo;
      decodeWindowHi = hi;
      var now = Date.now();
      var i;
      /* Nejdřív ve směru pohybu (od nejbližšího), pak zbytek. */
      if (decodeWindowDir > 0) {
        for (i = c + 1; i <= hi; i += 1) primeDecodedFrame(images[i], now);
        for (i = c - 1; i >= lo; i -= 1) primeDecodedFrame(images[i], now);
      } else {
        for (i = c - 1; i >= lo; i -= 1) primeDecodedFrame(images[i], now);
        for (i = c + 1; i <= hi; i += 1) primeDecodedFrame(images[i], now);
      }
    }

    /* Mobil: od horního okraje vymaže snímek do černé (pozadí sekce).
       Každým snímkem se pás zúží; na 25. snímku už není. Desktop beze změny. */
    function applyMobileTopDecay(frameIndex) {
      if (!ctx || useWideMediaAssets()) return;
      var i = frameIndex | 0;
      if (i < 0 || i >= MOBILE_TOP_DECAY_GONE_INDEX) return;
      var t = (MOBILE_TOP_DECAY_GONE_INDEX - i) / MOBILE_TOP_DECAY_GONE_INDEX;
      var cw = canvasCssW;
      var ch = canvasCssH;
      if (cw < 2 || ch < 2 || t <= 0) return;
      var fadeH = Math.max(2, ch * MOBILE_TOP_DECAY_MAX_RATIO * t);
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      var g = ctx.createLinearGradient(0, 0, 0, fadeH);
      g.addColorStop(0, 'rgba(0,0,0,1)');
      g.addColorStop(0.28, 'rgba(0,0,0,0.62)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, cw, fadeH);
      ctx.restore();
    }

    function paintFrame(index) {
      if (!totalFrames) return;
      var i = Math.max(0, Math.min(maxFrameIndex, index | 0));
      var img = images[i];
      if (!img || !img.complete || !img.naturalWidth) {
        if (!autoplayPlaying && (!img || !img.complete)) boostFramesNearScrub(i);
        var k;
        for (k = i; k >= 0; k -= 1) {
          if (images[k] && images[k].complete && images[k].naturalWidth) {
            img = images[k];
            i = k;
            break;
          }
        }
      }
      if (!img || !img.complete || !img.naturalWidth) return;
      if (i === lastDrawnIndex) {
        currentFrameIndex = i;
        return;
      }
      currentFrameIndex = i;
      drawCover(img);
      applyMobileTopDecay(i);
      syncIntroFade(i);
      lastDrawnIndex = i;
      syncDecodeWindow(i, false);
      if (canvas) {
        canvas.classList.remove('moje-s2b__canvas--awaiting-first');
        canvas.classList.add('moje-s2b__canvas--visible');
      }
    }

    function setLoaderProgress(pct) {
      var p = Math.max(0, Math.min(100, pct));
      if (loaderFill) loaderFill.style.width = p + '%';
      if (loaderPct) loaderPct.textContent = Math.round(p) + '%';
    }

    function hideLoader() {
      if (loader) {
        loader.classList.add('moje-s2b__loader--hide');
        loader.setAttribute('aria-hidden', 'true');
      }
    }

    function isProgrammaticNav() {
      return Date.now() < programmaticNavUntil;
    }

    function clearProgrammaticTarget() {
      programmaticTargetY = NaN;
    }

    function clearProgrammaticNav() {
      programmaticNavUntil = 0;
      if (programmaticNavTimer) {
        clearTimeout(programmaticNavTimer);
        programmaticNavTimer = 0;
      }
      clearProgrammaticTarget();
      document.documentElement.classList.remove('moje-s2b-external-scroll-nav');
      if (document.body) document.body.classList.remove('moje-s2b-external-scroll-nav');
    }

    function markProgrammaticNav(ms) {
      var dur = Math.max(400, Number(ms) || 1800);
      var until = Date.now() + dur;
      if (until > programmaticNavUntil) programmaticNavUntil = until;
      document.documentElement.classList.add('moje-s2b-external-scroll-nav');
      if (document.body) document.body.classList.add('moje-s2b-external-scroll-nav');
      if (programmaticNavTimer) clearTimeout(programmaticNavTimer);
      var remain = Math.max(50, programmaticNavUntil - Date.now());
      programmaticNavTimer = setTimeout(function () {
        programmaticNavTimer = 0;
        if (Date.now() < programmaticNavUntil) return;
        clearProgrammaticTarget();
        document.documentElement.classList.remove('moje-s2b-external-scroll-nav');
        if (document.body) document.body.classList.remove('moje-s2b-external-scroll-nav');
        if (pendingAutoplayFromNav) tryStartPendingAutoplay();
        requestTick();
      }, remain + 50);
    }

    function isJumpToSequenceStart(y) {
      var start = pinStartY;
      if (!(start > 8) || !Number.isFinite(y)) return false;
      return y >= start - 48 && y <= start + 64;
    }

    function isS2bIntroNavTarget(y) {
      if (autoplayConsumed || autoplayPlaying) return false;
      var start = pinStartY;
      if (!(start > 8) || !Number.isFinite(y)) return false;
      var dock = 0;
      try {
        dock = pricingDockY();
      } catch (errDock) {
        dock = 0;
      }
      if (!Number.isFinite(dock) || dock < start) {
        dock = start + Math.max(0, sequencePx);
      }
      return y >= start - 48 && y <= dock + 64;
    }

    function closeSiteMenuDrawer() {
      var drawer = document.querySelector('header-drawer');
      var details = document.getElementById('Details-menu-drawer-container');
      var summary;
      var headerEl;
      if (!details) return;
      summary = details.querySelector('summary');
      if (details.hasAttribute('open') && drawer && typeof drawer.closeMenuDrawer === 'function' && summary) {
        try {
          drawer.closeMenuDrawer({ type: 'click' }, summary);
        } catch (errClose) {}
      }
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      headerEl = document.querySelector('.header.menu-open') || document.querySelector('.header');
      if (headerEl) headerEl.classList.remove('menu-open');
      if (document.body) {
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
      }
    }

    function applyS2bScrollFreezePadding() {
      var html = document.documentElement;
      var gap = Math.max(0, window.innerWidth - html.clientWidth);
      if (gap > 0) html.style.setProperty('--moje-s2b-autoplay-sb', gap + 'px');
      else html.style.removeProperty('--moje-s2b-autoplay-sb');
    }

    function clearS2bScrollFreezePadding() {
      var html = document.documentElement;
      if (html.classList.contains('moje-s2b-autoplay-lock') || html.classList.contains('moje-s2b-terraform-lock')) {
        return;
      }
      html.style.removeProperty('--moje-s2b-autoplay-sb');
    }

    function lockS2bChrome(mode) {
      var html = document.documentElement;
      chromeLockMode = mode || '';
      html.classList.toggle('moje-s2b-chrome-lock', !!mode);
      html.classList.toggle('moje-s2b-chrome-lock--hide-spy', mode === 'terraform');
      html.classList.toggle('moje-s2b-chrome-lock--spy-inert', mode === 'autoplay');
      if (mode === 'terraform') {
        if (!html.classList.contains('moje-s2b-terraform-lock')) {
          applyS2bScrollFreezePadding();
          html.classList.add('moje-s2b-terraform-lock');
        }
        setScrollY(terraformLockY);
      } else if (mode === 'autoplay') {
        html.classList.remove('moje-s2b-terraform-lock');
      } else {
        html.classList.remove('moje-s2b-terraform-lock');
        clearS2bScrollFreezePadding();
      }
      closeSiteMenuDrawer();
    }

    function unlockS2bChrome(fromMode) {
      var html;
      if (fromMode && chromeLockMode && chromeLockMode !== fromMode) return;
      html = document.documentElement;
      html.classList.remove(
        'moje-s2b-chrome-lock',
        'moje-s2b-chrome-lock--hide-spy',
        'moje-s2b-chrome-lock--spy-inert',
        'moje-s2b-terraform-lock'
      );
      chromeLockMode = '';
      clearS2bScrollFreezePadding();
    }

    function pinPricingForTerraform() {
      /*
       * overflow:hidden na html/body ruší position:sticky. Když nejsme přesně
       * na kotvě ceníku, inner odskočí mimo viewport a video hraje „naslepo“
       * na černém pozadí. Nejdřív fixed pin přes celou obrazovku, až potom lock.
       */
      if (journey === 'below' || journey === 'buffer') {
        journey = 'pricing';
        atPricing = true;
        pricingLocked = true;
        belowArmed = false;
      }
      pricingUseFixedPin = true;
      if (!pricingVisible) showPricingVisual();
      else if (root) root.classList.add('moje-s2b--pricing-active');
      setFixedPin(true);
      if (innerEl) void innerEl.offsetHeight;
      var dock = Math.max(0, Math.round(pricingDockY()));
      terraformLockY = dock;
      setScrollY(dock);
      lastScrollYForDir = dock;
    }

    function pinTerraformScroll() {
      if (!pricingTransitioning) return false;
      if (!mobileFixedPin) setFixedPin(true);
      setScrollY(terraformLockY);
      lastScrollYForDir = terraformLockY;
      return true;
    }

    function stopPendingAutoplayWatch() {
      if (pendingAutoplayWatchRaf) {
        cancelAnimationFrame(pendingAutoplayWatchRaf);
        pendingAutoplayWatchRaf = 0;
      }
    }

    function armPendingAutoplayWatch() {
      if (pendingAutoplayWatchRaf) return;
      function tick() {
        pendingAutoplayWatchRaf = 0;
        if (!pendingAutoplayFromNav || autoplayPlaying || autoplayConsumed) return;
        if (tryStartPendingAutoplay()) return;
        pendingAutoplayWatchRaf = requestAnimationFrame(tick);
      }
      pendingAutoplayWatchRaf = requestAnimationFrame(tick);
    }

    function pendingAutoplayHasArrived() {
      var y;
      if (!(pinStartY > 8)) return false;
      y = getScrollY();
      if (Math.abs(y - pinStartY) <= 2) {
        pendingAutoplaySettledFrames += 1;
        return pendingAutoplayScrollEnded || pendingAutoplaySettledFrames >= 3;
      }
      pendingAutoplaySettledFrames = 0;
      if (pendingAutoplayScrollEnded && Math.abs(y - pinStartY) <= 48) {
        pinStartY = y;
        pinStartCached = true;
        return true;
      }
      return false;
    }

    function tryStartPendingAutoplay() {
      if (window.__mojeForceScrollTopUntil && Date.now() < window.__mojeForceScrollTopUntil) return false;
      if (!pendingAutoplayFromNav) return false;
      beginDefaultSequenceLoad();
      holdPipelineForDefaultSequence();
      if (autoplayConsumed || autoplayPlaying) {
        pendingAutoplayFromNav = false;
        stopPendingAutoplayWatch();
        return false;
      }
      if (!pendingAutoplayHasArrived()) return false;
      if (!framesReadyForAutoplay()) {
        paintFrame(0);
        return false;
      }
      pendingAutoplayFromNav = false;
      pendingAutoplayScrollEnded = false;
      pendingAutoplaySettledFrames = 0;
      stopPendingAutoplayWatch();
      clearProgrammaticNav();
      startAutoplay({ fromNav: true });
      if (autoplayPlaying || autoplayConsumed) return true;
      pendingAutoplayFromNav = true;
      paintFrame(0);
      armPendingAutoplayWatch();
      return false;
    }

    function isYInSequence(y) {
      var start = pinStartY;
      var end = pinStartY + Math.max(0, sequencePx);
      if (!(start > 8) || !Number.isFinite(y)) return false;
      return y >= start - 2 && y < end - 0.5;
    }

    function visualScrollY() {
      var live = getScrollY();
      if (!Number.isFinite(programmaticTargetY)) return live;
      if (Math.abs(live - programmaticTargetY) <= 8) {
        clearProgrammaticTarget();
        return live;
      }
      if (isYInSequence(programmaticTargetY)) return programmaticTargetY;
      clearProgrammaticTarget();
      return live;
    }

    function revealSequenceAtY(y) {
      refreshPinStart(true);
      if (!isYInSequence(y)) return false;
      var local = y - pinStartY;
      var seqEnd = Math.max(0, sequencePx);
      if (journey !== 'sequence') enterSequence();
      else pinForJourney();
      setFixedPin(true);
      if (innerEl) void innerEl.offsetHeight;
      var t = seqEnd <= 0 ? 1 : Math.max(0, Math.min(1, local / seqEnd));
      lastDrawnIndex = -1;
      paintFrame(Math.round(t * maxFrameIndex));
      applyMistProgress(mistProgressFromLocal(local));
      hidePricingVisual();
      return true;
    }

    function consumeAutoplayWithoutPlay() {
      pendingAutoplayFromNav = false;
      stopPendingAutoplayWatch();
      autoplayPlaying = false;
      autoplayConsumed = true;
      if (autoplayRaf) {
        cancelAnimationFrame(autoplayRaf);
        autoplayRaf = 0;
      }
      if (journey === 'autoplay') journey = 'pre';
      unlockAutoplayScroll();
      unlockS2bChrome('autoplay');
      hideLoader();
      dismissScrollHint();
    }

    function skipAutoplayForProgrammaticScroll(targetY, opts) {
      opts = opts || {};
      refreshPinStart(false);
      var startY = pinStartY;
      if (!Number.isFinite(startY) || startY <= 0) {
        refreshPinStart(true);
        startY = pinStartY;
      }
      var y = Number(targetY);
      if (!Number.isFinite(y)) y = getScrollY();
      var currentY = getScrollY();
      var landsInOrPast = startY > 8 && y >= startY - 12;
      var currentlyInOrPast = startY > 8 && currentY >= startY - 12;
      var jumpToSequence = isYInSequence(y);
      var jumpToStart = isJumpToSequenceStart(y) || !!opts.playAutoplay || isS2bIntroNavTarget(y);
      var wantSmooth = opts.smooth !== false;
      var dist = Math.abs((Number.isFinite(y) ? y : 0) - getScrollY());
      var navMs = Number(opts.duration);
      if (!Number.isFinite(navMs) || navMs <= 0) {
        navMs = wantSmooth ? Math.max(700, Math.min(1600, dist * 0.85 + 400)) : 400;
      }
      navMs = Math.max(400, navMs);

      programmaticTargetY = (!wantSmooth && jumpToSequence) ? y : NaN;

      function finishSequenceJump() {
        if (!jumpToSequence) return;
        consumeAutoplayWithoutPlay();
        if (wantSmooth) return;
        if (
          journey === 'pricing' ||
          journey === 'below' ||
          journey === 'buffer' ||
          pricingVisible
        ) {
          revealSequenceAtY(y);
        }
      }

      if (
        !autoplayConsumed &&
        !autoplayPlaying &&
        journey !== 'autoplay' &&
        jumpToStart
      ) {
        pendingAutoplayFromNav = true;
        pendingAutoplayScrollEnded = false;
        pendingAutoplaySettledFrames = 0;
        holdPipelineForDefaultSequence();
        lockS2bChrome('autoplay');
        markProgrammaticNav(navMs);
        armPendingAutoplayWatch();
        requestTick();
        return;
      }

      pendingAutoplayFromNav = false;

      if (!(startY > 8) && y > currentY + getViewportH() * 0.45) {
        markProgrammaticNav(navMs);
        consumeAutoplayWithoutPlay();
        finishSequenceJump();
        requestTick();
        return;
      }

      if (autoplayPlaying || journey === 'autoplay') {
        markProgrammaticNav(navMs);
        consumeAutoplayWithoutPlay();
        finishSequenceJump();
        requestTick();
        return;
      }
      if (!autoplayConsumed && landsInOrPast) {
        markProgrammaticNav(navMs);
        consumeAutoplayWithoutPlay();
        finishSequenceJump();
        requestTick();
        return;
      }
      if (autoplayConsumed && (landsInOrPast || currentlyInOrPast || jumpToSequence)) {
        markProgrammaticNav(navMs);
        finishSequenceJump();
        requestTick();
      }
    }

    function sequenceAssetKey(stage, packHint) {
      return resolveSequenceStage(stage) + ':' + (wantMobilePack(packHint) ? 'm' : 'd');
    }

    function packFrameWidth(packHint) {
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var slow = isSlowNetwork();
      if (wantMobilePack(packHint)) {
        var shortSide = Math.min(window.innerWidth || 0, window.innerHeight || 0) || 390;
        return Math.max(720, Math.min(slow ? 960 : 1440, Math.ceil(shortSide * dpr)));
      }
      var longSide = Math.max(window.innerWidth || 0, window.innerHeight || 0) || 1920;
      return Math.max(720, Math.min(slow ? 1280 : 1920, Math.ceil(longSide * dpr)));
    }

    function getSequenceStore(stage, packHint) {
      var id = resolveSequenceStage(stage);
      var key = sequenceAssetKey(id, packHint);
      var urls = sequenceUrlsFor(id, packHint);
      var width = packHint ? packFrameWidth(packHint) : getOptimalFrameWidth();
      var store = sequenceStore[key];
      if (
        store &&
        store.frameUrls &&
        store.frameUrls.join('|') === urls.join('|') &&
        Math.abs((store.width || width) - width) < 96
      ) {
        return store;
      }
      store = sequenceStore[key] = {
        images: [],
        loadedCount: 0,
        frameUrls: urls,
        width: width,
        key: key,
        stage: id,
        packHint: packHint || (wantMobilePack() ? 'm' : 'd')
      };
      return store;
    }

    /*
     * Paralelní stahování snímků. Save-Data = uživatel výslovně šetří data → 2 (dřív obráceně 6).
     * Zařízení s ≤ 2 GB RAM → 3. Rozjezd výchozí sekvence smí jet naplno, po ní míň
     * (zbytek se dočítá na pozadí a nesmí dusit ostatní média na stránce).
     */
    function getSeqLoadConcurrency() {
      if (isSaveDataEnabled()) return 2;
      if (isLowMemoryDevice()) return 3;
      if (isSlowNetwork()) return 3;
      if (!defaultSequenceFullyReady()) return useMobileMediaAssets() ? 6 : 8;
      return useMobileMediaAssets() ? 3 : 4;
    }

    /*
     * Evikce neaktivních packů: v paměti drží snímky jen aktivní store + volitelně jeden cílový
     * (rozjetý přechod / druhá orientace). Ostatním se zahodí <img> (encoded i decoded data),
     * ponechá se jen poslední snímek kvůli hand-off do pozadí ceníku. Znovunačtení jde z HTTP cache.
     */
    var MAX_RESIDENT_STORES = 2;
    function evictSequenceStore(store) {
      if (!store || !store.images || !store.images.length) return;
      var keepLast = store.frameUrls.length - 1;
      var i;
      var kept = 0;
      for (i = 0; i < store.images.length; i += 1) {
        var im = store.images[i];
        if (!im) continue;
        if (i === keepLast && im.complete && im.naturalWidth) {
          kept += 1;
          continue;
        }
        /* Rozběhnuté stahování: nejdřív korektně „usadit“ (uvolní slot seqLoadInFlight), pak zrušit. */
        if (typeof im.__s2bFinish === 'function') im.__s2bFinish(false);
        im.onload = null;
        im.onerror = null;
        try { im.removeAttribute('src'); } catch (eRm) {}
        store.images[i] = undefined;
      }
      store.loadedCount = kept;
      store.evictedAt = Date.now();
    }

    function retainSequenceStores(keepStores) {
      var keys = Object.keys(sequenceStore);
      var candidates = [];
      var k;
      for (k = 0; k < keys.length; k += 1) {
        var st = sequenceStore[keys[k]];
        if (!st || !st.images) continue;
        if (keepStores.indexOf(st) >= 0) continue;
        var resident = 0;
        var j;
        for (j = 0; j < st.images.length; j += 1) if (st.images[j]) resident += 1;
        if (resident <= 2) continue;
        candidates.push(st);
      }
      var slots = Math.max(0, MAX_RESIDENT_STORES - keepStores.length);
      if (candidates.length <= slots) return;
      candidates.sort(function (a, b) { return (a.lastUsed || 0) - (b.lastUsed || 0); });
      var q;
      for (q = 0; q < candidates.length - slots; q += 1) {
        /* Ve frontě mohou viset joby pro evikovaný store – vyhodit, ať se nestahuje dál. */
        var s2 = candidates[q];
        var w;
        for (w = seqLoadQueue.length - 1; w >= 0; w -= 1) {
          if (seqLoadQueue[w].store === s2) seqLoadQueue.splice(w, 1);
        }
        evictSequenceStore(s2);
      }
    }

    function enqueueFrameLoad(store, index, priority) {
      if (!store || !store.frameUrls[index] || store.images[index]) return;
      var q;
      for (q = 0; q < seqLoadQueue.length; q += 1) {
        if (seqLoadQueue[q].store === store && seqLoadQueue[q].index === index) {
          if (priority > seqLoadQueue[q].priority) seqLoadQueue[q].priority = priority;
          return;
        }
      }
      seqLoadQueue.push({ store: store, index: index, priority: priority || 0 });
    }

    function startFrameLoad(store, index, priority) {
      if (!store || !store.frameUrls[index] || store.images[index]) {
        seqLoadInFlight = Math.max(0, seqLoadInFlight - 1);
        scheduleSeqLoadPump();
        return;
      }
      var silentAtLoad = sequenceLoadSilent || store.images !== images;
      var fromEndAtLoad = sequenceLoadFromEnd;
      var settled = false;
      var img = new Image();
      img.decoding = 'async';
      try {
        /* Vysoká priorita jen pro rozjezd; dočítání na pozadí nesmí předbíhat ostatní média. */
        img.fetchPriority = (store.images === images && !defaultSequenceFullyReady() && index < AUTOPLAY_RUNWAY_FRAMES * 2) ? 'high' : 'auto';
      } catch (ePri) {}
      function finish(ok) {
        if (settled) return;
        settled = true;
        img.__s2bFinish = null;
        seqLoadInFlight = Math.max(0, seqLoadInFlight - 1);
        store.loadedCount += 1;
        store.lastUsed = Date.now();
        if (store.images === images) {
          loadedCount = store.loadedCount;
          if (!silentAtLoad) setLoaderProgress(loaderProgressPct());
          if (ok) primeFrameIfInWindow(index);
          /* Poslední snímek dorazil až po hand-off do ceníku (rebuffer give-up) → dokreslit. */
          var lateLastFrame = ok && index === maxFrameIndex && autoplayConsumed && pricingVisible && currentFrameIndex < maxFrameIndex;
          if (lateLastFrame) {
            paintFrame(maxFrameIndex);
          } else if (ok && (index === currentFrameIndex || (!fromEndAtLoad && index === 0))) {
            paintFrame(index === currentFrameIndex ? currentFrameIndex : 0);
            if (!silentAtLoad && !sequenceLayoutFrozen && !pendingAutoplayFromNav) {
              pinStartCached = false;
              syncIntroLayout();
              applySectionHeight();
              refreshPinStart(true);
            }
            if (index === 0) applyAdaptiveDomImages();
          }
          if (pendingAutoplayFromNav) tryStartPendingAutoplay();
          else if (!autoplayConsumed && !autoplayPlaying && autoplayWaitingForRunway) requestTick();
          if (autoplayPlaying && autoplayRebufferUntil >= 0) requestTick();
          markDefaultSequenceReady();
          maybeStartDeferredS2bMedia();
          if (loadedCount >= totalFrames && !silentAtLoad) hideLoader();
        }
        scheduleSeqLoadPump();
      }
      img.__s2bFinish = finish;
      img.onload = function () { finish(true); };
      img.onerror = function () { finish(false); };
      store.images[index] = img;
      img.src = store.frameUrls[index];
      if (img.complete) finish(!!img.naturalWidth);
    }

    /* Loader ukazuje postup rozjezdu (runway), ne celé sekvence – po startu autoplay mizí. */
    function loaderProgressPct() {
      var target = autoplayConsumed || autoplayPlaying
        ? totalFrames
        : Math.min(totalFrames, AUTOPLAY_RUNWAY_FRAMES);
      if (!target) return 100;
      return (Math.min(target, countReadyRunway(0)) / target) * 100;
    }

    function scheduleSeqLoadPump() {
      if (seqLoadPumpTimer) return;
      seqLoadPumpTimer = 1;
      var run = function () {
        seqLoadPumpTimer = 0;
        pumpSeqLoadQueue();
      };
      if (typeof queueMicrotask === 'function') queueMicrotask(run);
      else setTimeout(run, 0);
    }

    function pumpSeqLoadQueue() {
      if (seqLoadPumping) {
        scheduleSeqLoadPump();
        return;
      }
      seqLoadPumping = true;
      try {
        var cap = getSeqLoadConcurrency();
        var defaultOnly = !defaultSequenceFullyReady();
        while (seqLoadInFlight < cap && seqLoadQueue.length) {
          seqLoadQueue.sort(function (a, b) { return b.priority - a.priority; });
          var pick = -1;
          var qi;
          for (qi = 0; qi < seqLoadQueue.length; qi += 1) {
            var cand = seqLoadQueue[qi];
            if (!cand || !cand.store || cand.store.images[cand.index]) {
              seqLoadQueue.splice(qi, 1);
              qi -= 1;
              continue;
            }
            if (defaultOnly && cand.store.images !== images) continue;
            pick = qi;
            break;
          }
          if (pick < 0) break;
          var job = seqLoadQueue.splice(pick, 1)[0];
          seqLoadInFlight += 1;
          startFrameLoad(job.store, job.index, job.priority);
        }
      } finally {
        seqLoadPumping = false;
      }
    }

    function enqueueStoreFrames(store, opts) {
      opts = opts || {};
      if (!store || !store.frameUrls.length) return;
      var n = store.frameUrls.length;
      var fromEnd = !!opts.fromEnd;
      var boost = Number(opts.boost) || 0;
      var isActive = store.images === images;
      var runway = Math.min(n, 32);
      var order = [];
      var i;
      if (fromEnd) {
        for (i = n - 1; i >= 0; i -= 1) order.push(i);
      } else {
        for (i = 0; i < n; i += 1) order.push(i);
      }
      for (i = 0; i < order.length; i += 1) {
        var idx = order[i];
        var pri = boost;
        if (isActive && !fromEnd) {
          pri += idx < runway ? (140 - idx) : 80;
        } else if (isActive && fromEnd) {
          pri += idx >= n - runway ? 90 : 28;
        } else {
          pri += idx >= n - 8 ? 36 : 10;
        }
        pri -= i * 0.01;
        enqueueFrameLoad(store, idx, pri);
      }
    }

    function loadAllFrames(opts) {
      opts = opts || {};
      sequenceLoadFromEnd = !!opts.fromEnd;
      if (!totalFrames) {
        if (!sequenceLoadSilent) hideLoader();
        maybeStartDeferredS2bMedia(true);
        return;
      }
      enqueueStoreFrames(getSequenceStore(activeSequenceStage), {
        fromEnd: !!opts.fromEnd,
        boost: 20
      });
      pumpSeqLoadQueue();
    }

    /* Celá sekvence jiné karty se načítá až na uživatelskou akci (klik na kartu / přepnutí stage). */
    function preloadSequenceStage(stage, opts) {
      opts = opts || {};
      var store = getSequenceStore(stage);
      store.lastUsed = Date.now();
      retainSequenceStores([getSequenceStore(activeSequenceStage), store]);
      enqueueStoreFrames(store, {
        fromEnd: opts.fromEnd !== false,
        boost: Number(opts.boost) || 0
      });
      pumpSeqLoadQueue();
      return store;
    }

    /*
     * Ostatní sekvence: jen poslední snímek (hand-off do pozadí ceníku po teraformaci).
     * Dřív se stahovaly celé (2 × ~30–35 MB) hned po výchozí sekvenci.
     */
    function preloadOtherSequenceLastFrames() {
      var stages = [1, 2, 3];
      var s;
      for (s = 0; s < stages.length; s += 1) {
        var id = resolveSequenceStage(stages[s]);
        if (id === activeSequenceStage) continue;
        var store = getSequenceStore(id);
        var last = store.frameUrls.length - 1;
        if (last < 0) continue;
        enqueueFrameLoad(store, last, 12);
      }
      pumpSeqLoadQueue();
    }

    function runWhenIdle(fn, timeoutMs) {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(function () { fn(); }, { timeout: timeoutMs || 4000 });
      } else {
        setTimeout(fn, 600);
      }
    }

    var otherStagesPreloadArmed = false;
    var defaultSequenceLoadStarted = false;

    function holdPipelineForDefaultSequence() {
      if (defaultSequenceFullyReady()) {
        window.__mojeS2bHoldPipeline = false;
        return;
      }
      window.__mojeS2bHoldPipeline = true;
    }

    function markDefaultSequenceReady() {
      if (window.__mojeS2bDefaultReady) return;
      if (!defaultSequenceFullyReady()) return;
      window.__mojeS2bDefaultReady = true;
      window.__mojeS2bHoldPipeline = false;
      try {
        document.dispatchEvent(new CustomEvent('moje:s2b-default-ready', { detail: { sectionId: sectionId } }));
      } catch (eReady) {}
      maybeStartDeferredS2bMedia();
    }

    /*
     * P3 média po dokončení výchozí sekvence (nebo na akci uživatele – force):
     * pozadí ceníku + poslední snímky ostatních sekvencí na idle. Žádný opačný pack
     * (desktop média na mobilu „pro jistotu“ = ~127 MB) – ten se načítá až při reálné rotaci
     * v applyMediaPackForViewport(). Terraform videa řeší IntersectionObserver + intent.
     */
    function maybeStartDeferredS2bMedia(force) {
      if (!force && !defaultSequenceFullyReady()) return;
      applyAdaptiveDomImages();
      warmPricingStageImages({ all: true });
      if (otherStagesPreloadArmed) return;
      otherStagesPreloadArmed = true;
      runWhenIdle(preloadOtherSequenceLastFrames, 6000);
    }

    function isSaveDataEnabled() {
      try {
        var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        return !!(conn && conn.saveData);
      } catch (eSave) {
        return false;
      }
    }

    function isLowMemoryDevice() {
      try {
        return !!(navigator.deviceMemory && navigator.deviceMemory <= 2);
      } catch (eMem) {
        return false;
      }
    }

    function beginDefaultSequenceLoad() {
      if (defaultSequenceLoadStarted) return;
      if (!window.__mojeLaserHeroReady && document.querySelector('.laser-section-wrapper')) {
        return;
      }
      defaultSequenceLoadStarted = true;
      loadAllFrames();
    }

    function syncIntroPhase() {
      var nodes = root.querySelectorAll('[data-s2b-seq-phase]');
      var i;
      for (i = 0; i < nodes.length; i += 1) {
        nodes[i].classList.toggle(
          'is-active',
          nodes[i].getAttribute('data-s2b-seq-phase') === String(activeSequenceStage)
        );
      }
      if (root) root.setAttribute('data-s2b-seq-phase', String(activeSequenceStage));
    }

    function bindActiveIntroLoad() {
      var hazeImg = introImageEl();
      function onHazeReady() {
        if (sequenceLayoutFrozen || pendingAutoplayFromNav) return;
        pinStartCached = false;
        updateMetrics({ refreshPinStart: true });
        syncIntroFade(currentFrameIndex);
        requestTick();
      }
      if (!hazeImg) return;
      if (hazeImg.complete && hazeImg.naturalWidth) onHazeReady();
      else hazeImg.addEventListener('load', onHazeReady);
    }

    function bindSequenceState(stage) {
      var store = getSequenceStore(stage);
      var changed = store.images !== images;
      activeSequenceStage = store.stage;
      frameUrls = store.frameUrls;
      images = store.images;
      loadedCount = store.loadedCount;
      totalFrames = frameUrls.length;
      maxFrameIndex = Math.max(0, totalFrames - 1);
      store.lastUsed = Date.now();
      if (changed) {
        /* Decode okno patří k předchozímu store – nový si ho postaví při prvním paintu. */
        resetDecodeWindow();
        decodeStoreRef = images;
        retainSequenceStores([store]);
      }
    }

    function flushFrozenSequenceLayout() {
      if (!sequenceLayoutFrozen) return;
      sequenceLayoutFrozen = false;
      syncIntroPhase();
      bindActiveIntroLoad();
      syncIntroLayout();
      applySectionHeight({ compensate: true });
      refreshPinStart(true);
    }

    function switchSequenceTo(stage, opts) {
      opts = opts || {};
      var next = resolveSequenceStage(stage);
      var nextUrls = sequenceUrlsFor(next);
      if (next === activeSequenceStage && frameUrls.join('|') === nextUrls.join('|')) {
        if (!sequenceLayoutFrozen) syncIntroPhase();
        return;
      }
      bindSequenceState(next);
      lastDrawnIndex = -1;
      if (opts.fromEnd) currentFrameIndex = maxFrameIndex;
      sequenceLoadSilent = !!opts.silent;
      var freezeLayout = !!opts.freezeLayout ||
        journey === 'pricing' ||
        journey === 'buffer' ||
        journey === 'below';
      if (freezeLayout) sequenceLayoutFrozen = true;
      if (!sequenceLayoutFrozen) syncIntroPhase();
      applyAdaptiveDomImages();
      bindActiveIntroLoad();
      loadAllFrames({ fromEnd: !!opts.fromEnd });
      /* Dřív se tu dekódovalo všech 185 snímků najednou (~1,5 GB RGBA) – teď jen okno kolem aktuálního. */
      decodeWindowDir = opts.fromEnd ? -1 : 1;
      syncDecodeWindow(currentFrameIndex, true);
      if (opts.fromEnd && images[maxFrameIndex]) primeDecodedFrame(images[maxFrameIndex]);
      paintFrame(currentFrameIndex);
      if (!sequenceLayoutFrozen) {
        syncIntroLayout();
        applySectionHeight();
      }
      sequenceLoadSilent = false;
    }

    function frameIsSettled(index) {
      var img = images[index];
      return !!(img && img.complete);
    }

    function frameCanPaint(index) {
      var img = images[index];
      return !!(img && img.complete && img.naturalWidth);
    }

    function countReadyRunway(fromIndex) {
      var i;
      var n = 0;
      var start = Math.max(0, fromIndex | 0);
      for (i = start; i <= maxFrameIndex; i += 1) {
        if (frameIsSettled(i)) n += 1;
        else break;
      }
      return n;
    }

    function defaultSequenceFullyReady() {
      if (!totalFrames) return true;
      return countReadyRunway(0) >= totalFrames;
    }

    /* Autoplay smí startovat po runway (výchozí 18 snímků), ne až po 100 %. */
    function autoplayRunwayTarget() {
      return Math.min(totalFrames, AUTOPLAY_RUNWAY_FRAMES);
    }

    function framesReadyForAutoplay() {
      if (!totalFrames) return true;
      if (!frameCanPaint(0)) return false;
      if (defaultSequenceFullyReady()) return true;
      return countReadyRunway(0) >= autoplayRunwayTarget();
    }

    function boostUpcomingAutoplayFrames(fromIndex) {
      var store = getSequenceStore(activeSequenceStage);
      var start = Math.max(0, fromIndex | 0);
      var to = Math.min(maxFrameIndex, start + 24);
      var i;
      for (i = start; i <= to; i += 1) {
        enqueueFrameLoad(store, i, 220 - (i - start));
      }
      pumpSeqLoadQueue();
    }

    /*
     * Ruční scrub narazil na ještě nestažený snímek: přednostně stáhnout okolí ve směru pohybu
     * (streamované načítání už nedrží scroll-lock, takže sekvence může být rozehraná dřív než 100 %).
     */
    var lastScrubBoostAt = 0;
    var lastScrubBoostIdx = -1;
    function boostFramesNearScrub(target) {
      /* Před rozjezdem výchozí sekvence (čeká se na hero) nic nepředbíhat. */
      if (!defaultSequenceLoadStarted) return;
      var now = Date.now();
      if (now - lastScrubBoostAt < 120 && Math.abs(target - lastScrubBoostIdx) < 4) return;
      lastScrubBoostAt = now;
      lastScrubBoostIdx = target;
      var store = getSequenceStore(activeSequenceStage);
      if (!store || store.images !== images) return;
      var dir = decodeWindowDir > 0 ? 1 : -1;
      var i;
      var idx;
      for (i = 0; i <= 24; i += 1) {
        idx = target + dir * i;
        if (idx < 0 || idx > maxFrameIndex) break;
        enqueueFrameLoad(store, idx, 240 - i);
      }
      for (i = 1; i <= 6; i += 1) {
        idx = target - dir * i;
        if (idx < 0 || idx > maxFrameIndex) break;
        enqueueFrameLoad(store, idx, 200 - i);
      }
      pumpSeqLoadQueue();
    }

    /*
     * Po autoplayi je uživatel na ceníku a scrubuje zpátky od konce → zbytek sekvence dočíst
     * od posledního snímku dolů (výchozí pořadí bylo vzestupné, konec by přišel jako poslední).
     */
    function prioritizeRemainingFramesFromEnd() {
      var store = getSequenceStore(activeSequenceStage);
      if (!store || store.images !== images || !totalFrames) return;
      var i;
      var rank = 0;
      for (i = maxFrameIndex; i >= 0; i -= 1) {
        if (store.images[i]) continue;
        enqueueFrameLoad(store, i, 190 - Math.min(80, rank * 0.5));
        rank += 1;
      }
      if (rank) pumpSeqLoadQueue();
    }

    function setFixedPin(active) {
      if (!root || !innerEl) return;
      if (active === mobileFixedPin) return;
      /*
       * Přepínání fixed ↔ sticky mění containing block (viewport vs. sekce).
       * Šířku držíme z předchozího boxu, ať karty i pozadí nezmění ořez.
       */
      ignoreMetricsUntil = Date.now() + 250;
      var prevW = Math.round(innerEl.getBoundingClientRect().width);
      if (typeof window.mojeFreezeViewportLock === 'function') {
        if (active && !mobileFixedPin) window.mojeFreezeViewportLock(true);
        if (!active && mobileFixedPin) window.mojeFreezeViewportLock(false);
      }
      mobileFixedPin = active;
      root.classList.toggle('moje-s2b--mobile-fixed-pin', active);
      innerEl.classList.toggle('moje-s2b__inner--fixed-pin', active);
      if (prevW > 0) {
        innerEl.style.width = prevW + 'px';
        innerEl.style.maxWidth = prevW + 'px';
      }
      if (mobileFixedPin) {
        innerEl.style.top = '0px';
        innerEl.style.left = '0px';
      } else {
        innerEl.style.top = '';
        innerEl.style.left = '';
      }
    }

    function pinForJourney() {
      if (journey === 'autoplay' || journey === 'sequence' || journey === 'buffer') {
        setFixedPin(true);
        return;
      }
      if (journey === 'pricing') {
        setFixedPin(pricingUseFixedPin);
        return;
      }
      setFixedPin(false);
    }

    function mountScrollHint() {
      if (!document.body) return;
      if (scrollHintEl && scrollHintEl.parentNode !== document.body) {
        document.body.appendChild(scrollHintEl);
      }
      if (seqMouseEl && seqMouseEl.parentNode !== document.body) {
        document.body.appendChild(seqMouseEl);
      }
    }

    function dismissScrollHint() {
      if (scrollHintGone) return;
      scrollHintGone = true;
      if (!scrollHintEl) return;
      scrollHintEl.classList.remove('is-visible');
      scrollHintEl.classList.add('is-gone');
    }

    function inManualSequenceScroll() {
      var y;
      var start;
      var end;
      if (!autoplayConsumed || autoplayPlaying) return false;
      if (journey === 'autoplay') return false;
      start = pinStartY;
      end = sequenceEndY();
      if (!(start > 8) || !(end > start + 8)) return false;
      y = visualScrollY();
      return y >= start - 2 && y < end - 4;
    }

    function syncSeqMouseHint() {
      if (!seqMouseEl) return;
      seqMouseEl.classList.toggle('is-visible', inManualSequenceScroll());
    }

    function syncScrollHint() {
      if (!scrollHintEl) return;
      if (scrollHintGone) return;
      if (
        autoplayPlaying ||
        autoplayConsumed ||
        journey === 'autoplay' ||
        journey === 'sequence' ||
        journey === 'buffer' ||
        journey === 'pricing' ||
        journey === 'below'
      ) {
        dismissScrollHint();
        return;
      }
      if (pinStartY > 0 && getScrollY() >= pinStartY - 0.5) {
        dismissScrollHint();
        return;
      }
      var vh = getViewportH();
      var rect = root.getBoundingClientRect();
      var inView = rect.bottom > 28 && rect.top < vh;
      scrollHintEl.classList.toggle('is-visible', inView);
    }

    function applyMistProgress(progress) {
      var p = Number(progress);
      if (!Number.isFinite(p)) p = 0;
      p = Math.max(0, Math.min(1, p));
      if (root) {
        root.style.setProperty('--mist-progress', p.toFixed(4));
        root.classList.toggle('moje-s2b--in-buffer', p > 0.001);
      }
    }

    function bufferRawFromLocal(local) {
      var seqEnd = Math.max(0, sequencePx);
      var buf = Math.max(1, bufferPx);
      return (seqEnd + buf - local) / buf;
    }

    function mistProgressFromLocal(local) {
      var seqEnd = Math.max(0, sequencePx);
      var buf = Math.max(1, bufferPx);
      if (local >= seqEnd + buf) return 0;
      if (local <= seqEnd) {
        var blend = Math.max(24, seqEnd * 0.05);
        var dist = seqEnd - local;
        if (dist >= blend) return 0;
        return 1 - dist / blend;
      }
      var raw = (seqEnd + buf - local) / buf;
      if (raw <= BUFFER_DEAD_PCT) return 0;
      return Math.min(1, (raw - BUFFER_DEAD_PCT) / (1 - BUFFER_DEAD_PCT));
    }

    function clearDockAnchor() {
      if (dockAnchorTimer) {
        clearTimeout(dockAnchorTimer);
        dockAnchorTimer = 0;
      }
    }

    function snapToPricingDock() {
      if (isProgrammaticNav()) return;
      if (Date.now() < dockSnapLockUntil) return;
      var dock = Math.round(pricingDockY());
      if (Math.abs(getScrollY() - dock) < 1.5) return;
      dockSnapLockUntil = Date.now() + 80;
      setScrollY(dock);
      applyMistProgress(0);
    }

    function queueDockAnchor(local) {
      if (isProgrammaticNav()) {
        clearDockAnchor();
        return;
      }
      if (autoplayPlaying || journey === 'autoplay' || journey === 'sequence') {
        clearDockAnchor();
        return;
      }
      if (pricingTransitioning) {
        clearDockAnchor();
        return;
      }
      var seqEnd = Math.max(0, sequencePx);
      var buf = Math.max(1, bufferPx);
      var dockLocal = seqEnd + buf;
      if (local < seqEnd - 1 || local > dockLocal + 4) {
        clearDockAnchor();
        return;
      }
      var y = getScrollY();
      if (y < lastDockAnchorY - 0.4) dockAnchorDir = -1;
      else if (y > lastDockAnchorY + 0.4) dockAnchorDir = 1;
      lastDockAnchorY = y;
      var raw = (dockLocal - local) / buf;

      if (raw <= BUFFER_DEAD_PCT) {
        if (dockAnchorDir < 0) {
          clearDockAnchor();
          dockAnchorTimer = setTimeout(function () {
            dockAnchorTimer = 0;
            if (autoplayPlaying || journey === 'sequence') return;
            var loc = localScroll();
            var r = bufferRawFromLocal(loc);
            if (r > 0 && r <= BUFFER_DEAD_PCT) snapToPricingDock();
          }, 180);
          return;
        }
        snapToPricingDock();
        return;
      }
      if (dockAnchorDir > 0) {
        clearDockAnchor();
        dockAnchorTimer = setTimeout(function () {
          dockAnchorTimer = 0;
          if (autoplayPlaying || journey === 'sequence') return;
          var loc = localScroll();
          var r = bufferRawFromLocal(loc);
          if (r > BUFFER_DEAD_PCT && r < 1) snapToPricingDock();
        }, 220);
        return;
      }
      clearDockAnchor();
    }

    function clearPricingSeqRestoreTimer() {
      if (pricingSeqRestoreTimer) {
        clearTimeout(pricingSeqRestoreTimer);
        pricingSeqRestoreTimer = 0;
      }
    }

    function clearPricingFadeRetryTimer() {
      if (pricingFadeRetryTimer) {
        clearTimeout(pricingFadeRetryTimer);
        pricingFadeRetryTimer = 0;
      }
    }

    function lastSequenceFrameReady() {
      var img = images[maxFrameIndex];
      return !!(img && img.complete && img.naturalWidth);
    }

    function syncPricingCanvasBg() {
      if (!pricingScene) return false;
      paintFrame(maxFrameIndex);
      return lastSequenceFrameReady();
    }

    function showPricingVisual() {
      if (!pricingScene) return;
      var firstReveal = !pricingVisible;
      cancelPricingCardsExit({ restore: true });
      pricingExiting = false;
      pricingVisible = true;
      if (root) root.classList.add('moje-s2b--pricing-active');
      if (canvas) {
        canvas.style.opacity = '';
        canvas.style.visibility = '';
      }
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-out');
      pricingScene.classList.add('moje-s2b__pricing-scene--visible');
      pricingScene.classList.add('moje-s2b__pricing-scene--cards-in');
      pricingScene.setAttribute('aria-hidden', 'false');
      syncPricingCanvasBg();
      warmPricingStageImages();
      syncPricingTouchCapture();
      if (firstReveal) scheduleSnapPricingCarouselToActiveCard();
      syncPricingCarouselHintsLayout();
      requestAnimationFrame(function () {
        syncPricingFeaturesOverflow();
        syncPricingCarouselHintsLayout();
      });
    }

    function hidePricingVisual() {
      if (!pricingScene) return;
      cancelPricingCardsExit({ restore: false });
      pricingExiting = false;
      pricingVisible = false;
      if (root) {
        root.classList.remove('moje-s2b--pricing-active');
      }
      pricingScene.classList.remove('moje-s2b__pricing-scene--visible');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-in');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-out');
      pricingScene.classList.remove('moje-s2b__pricing-scene--seq-restore');
      pricingScene.classList.remove('moje-s2b__pricing-scene--carousel-loose');
      pricingScene.classList.remove('moje-s2b__pricing-scene--touch-capture');
      pricingScene.classList.remove('moje-s2b__pricing-scene--carousel-settling');
      pricingScene.setAttribute('aria-hidden', 'true');
      clearPricingCarouselPreviewClasses();
      resetPricingCarouselBgPan();
      collapseAllPricingFeatures(true);
      if (canvas) {
        canvas.style.opacity = '';
        canvas.style.visibility = '';
      }
    }

    function canLeavePricingDown() {
      return Date.now() >= pricingSettleUntil;
    }

    function enterPricing(opts) {
      opts = opts || {};
      var fromBelow = journey === 'below';
      var fromSequence = journey === 'sequence' || journey === 'autoplay' || journey === 'buffer';
      if (journey === 'pricing' && pricingVisible && !opts.force) {
        if (pricingExiting) showPricingVisual();
        pinForJourney();
        pricingLocked = true;
        return;
      }
      pricingUseFixedPin = !fromBelow && journey !== 'pre';
      journey = 'pricing';
      atPricing = true;
      pricingLocked = true;
      belowArmed = false;
      pricingSettleUntil = Date.now() + 280;
      applySectionHeight({ compensate: fromBelow });
      if (!fromBelow && !fromSequence) refreshPinStart(true);
      pinForJourney();
      paintFrame(maxFrameIndex);
      showPricingVisual();
      /* Karty jsou na obrazovce → warm metadat 2 přechodů z aktuální karty (ne 6 videí naplno). */
      startTerraformPreload(true);
      maybeStartDeferredS2bMedia(true);
      if (opts.snap !== false && !fromBelow) {
        var dock = Math.round(pricingDockY());
        if (Math.abs(getScrollY() - dock) > 2) setScrollY(dock);
        applyMistProgress(0);
      } else if (!fromSequence) {
        applyMistProgress(0);
      }
      lastDockAnchorY = getScrollY();
      dockAnchorDir = 0;
      requestAnimationFrame(function () {
        if (!pricingScene || journey !== 'pricing') return;
        pricingScene.classList.add('moje-s2b__pricing-scene--cards-in');
        if (!fromBelow) {
          scheduleSnapPricingCarouselToActiveCard();
          syncPricingFeaturesOverflow();
          syncPricingCarouselHintsLayout();
        }
        syncPricingTouchCapture();
      });
      persistS2bSession();
    }

    function enterSequence() {
      journey = 'sequence';
      atPricing = false;
      pricingLocked = false;
      dismissScrollHint();
      sequenceEnterUntil = Date.now() + 160;
      flushFrozenSequenceLayout();
      applySectionHeight({ compensate: false });
      pinForJourney();
      if (canvas) {
        canvas.style.opacity = '';
        canvas.style.visibility = '';
      }
    }

    function enterBuffer() {
      journey = 'buffer';
      atPricing = true;
      pricingLocked = true;
      pricingUseFixedPin = true;
      applySectionHeight({ compensate: false });
      pinForJourney();
      paintFrame(maxFrameIndex);
      showPricingVisual();
    }

    function enterBelow() {
      journey = 'below';
      atPricing = false;
      pricingLocked = false;
      belowArmed = false;
      pricingUseFixedPin = false;
      suppressPricingRelockUntil = Date.now() + 700;
      applySectionHeight({ compensate: false });
      setFixedPin(false);
      paintFrame(maxFrameIndex);
      showPricingVisual();
      applyMistProgress(0);
    }

    function autoplayYForFrame(index) {
      var t = maxFrameIndex > 0 ? Math.max(0, Math.min(1, index / maxFrameIndex)) : 1;
      return pinStartY + t * Math.max(0, sequencePx - 4);
    }

    function syncAutoplayScrollToFrame() {
      autoplayLockY = autoplayYForFrame(currentFrameIndex);
      setScrollY(autoplayLockY);
    }

    function autoplayScrollbarGapPx() {
      return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    }

    function lockAutoplayScroll(opts) {
      opts = opts || {};
      var live = getScrollY();
      var html = document.documentElement;
      var ideal = autoplayYForFrame(currentFrameIndex);
      if (opts.keepY || Math.abs(live - ideal) <= 24) {
        autoplayLockY = live;
      } else {
        autoplayLockY = ideal;
      }
      applyS2bScrollFreezePadding();
      if (!html.classList.contains('moje-s2b-autoplay-lock')) {
        html.classList.add('moje-s2b-autoplay-lock');
      }
      lockS2bChrome('autoplay');
      setFixedPin(true);
      if (!opts.keepY && Math.abs(getScrollY() - autoplayLockY) > 2) setScrollY(autoplayLockY);
    }

    function unlockAutoplayScroll() {
      var html = document.documentElement;
      html.classList.remove('moje-s2b-autoplay-lock');
      unlockS2bChrome('autoplay');
      clearS2bScrollFreezePadding();
    }

    function onAutoplayLockScroll() {
      if (!autoplayPlaying) return;
      if (isProgrammaticNav() && !pendingAutoplayFromNav) {
        consumeAutoplayWithoutPlay();
        requestTick();
        return;
      }
      setScrollY(autoplayLockY);
    }

    function onAutoplayLockWheel(event) {
      if (!autoplayPlaying) return;
      if (isProgrammaticNav() && !pendingAutoplayFromNav) {
        consumeAutoplayWithoutPlay();
        return;
      }
      if (event.cancelable) event.preventDefault();
      setScrollY(autoplayLockY);
    }

    function onAutoplayLockTouch(event) {
      if (!autoplayPlaying) return;
      if (isProgrammaticNav() && !pendingAutoplayFromNav) {
        consumeAutoplayWithoutPlay();
        return;
      }
      if (event.cancelable) event.preventDefault();
      setScrollY(autoplayLockY);
    }

    function showPricing() {
      enterPricing({ snap: false });
    }

    function hidePricing() {
      hidePricingVisual();
      pricingLocked = false;
    }

    function cancelPricingCardsExit(opts) {
      opts = opts || {};
      pricingFadeGen += 1;
      if (pricingCardsExitSceneTimer) {
        clearTimeout(pricingCardsExitSceneTimer);
        pricingCardsExitSceneTimer = null;
      }
      clearPricingFadeRetryTimer();
      pricingExiting = false;
      if (!pricingScene) return;
      var wasFading = pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit');
      if (opts.restore && wasFading && pricingVisible) {
        pricingScene.classList.add('moje-s2b__pricing-scene--seq-restore');
        pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit-active');
        pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit');
        clearPricingSeqRestoreTimer();
        var restoreGen = pricingFadeGen;
        pricingSeqRestoreTimer = setTimeout(function () {
          pricingSeqRestoreTimer = 0;
          if (restoreGen !== pricingFadeGen || !pricingScene) return;
          pricingScene.classList.remove('moje-s2b__pricing-scene--seq-restore');
        }, PRICING_CARDS_RESTORE_MS + 40);
        pricingFadeCooldownUntil = Date.now() + 180;
        return;
      }
      clearPricingSeqRestoreTimer();
      pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit-active');
      pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit');
      if (!opts.restore) {
        pricingScene.classList.remove('moje-s2b__pricing-scene--seq-restore');
      }
    }

    function finishPricingCardsExitSceneHide() {
      if (!pricingExiting) return;
      if (journey !== 'sequence') {
        cancelPricingCardsExit({ restore: true });
        return;
      }
      hidePricingVisual();
    }

    function onPricingSceneTransitionEnd(event) {
      if (!pricingScene || event.target !== pricingScene) return;
      if (event.propertyName !== 'opacity') return;
      if (!pricingExiting) return;
      if (!pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit-active')) return;
      finishPricingCardsExitSceneHide();
    }

    function beginPricingCardsExitForSequence() {
      if (!pricingScene) return;
      if (!pricingVisible) return;
      if (!pricingScene.classList.contains('moje-s2b__pricing-scene--visible')) return;
      if (pricingExiting || pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit')) return;
      if (Date.now() < pricingFadeCooldownUntil) {
        if (!pricingFadeRetryTimer) {
          pricingFadeRetryTimer = setTimeout(function () {
            pricingFadeRetryTimer = 0;
            if (journey === 'sequence' && pricingVisible) beginPricingCardsExitForSequence();
          }, Math.max(16, pricingFadeCooldownUntil - Date.now() + 12));
        }
        return;
      }
      clearPricingFadeRetryTimer();
      clearPricingSeqRestoreTimer();
      pricingFadeGen += 1;
      var gen = pricingFadeGen;
      pricingExiting = true;
      if (canvas) {
        canvas.style.opacity = '';
        canvas.style.visibility = '';
      }
      pricingScene.classList.remove('moje-s2b__pricing-scene--seq-restore');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-in');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-out');
      pricingScene.classList.add('moje-s2b__pricing-scene--phase2-exit');
      pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit-active');
      syncPricingTouchCapture();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (gen !== pricingFadeGen) return;
          if (!pricingScene || journey !== 'sequence') return;
          if (!pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit')) return;
          pricingScene.classList.add('moje-s2b__pricing-scene--phase2-exit-active');
        });
      });
      if (pricingCardsExitSceneTimer) {
        clearTimeout(pricingCardsExitSceneTimer);
        pricingCardsExitSceneTimer = null;
      }
      pricingCardsExitSceneTimer = setTimeout(function () {
        if (gen !== pricingFadeGen) return;
        finishPricingCardsExitSceneHide();
      }, PRICING_CARDS_EXIT_FADE_MS + 80);
    }

    function onPricingWheel(event) {
      if (Number.isFinite(programmaticTargetY)) clearProgrammaticTarget();
      if (pricingTransitioning) {
        if (event.cancelable) event.preventDefault();
        pinTerraformScroll();
        return;
      }
      if (autoplayPlaying || journey === 'autoplay') {
        onAutoplayLockWheel(event);
        return;
      }
      if (pricingTransitioning && journey === 'pricing') {
        if (event.cancelable) event.preventDefault();
      }
    }

    function isCarouselHorizontalTarget(event) {
      var target = event.target;
      if (!target || !target.closest) return false;
      return !!target.closest('.moje-s2b__pricing-carousel, .moje-s2b__pricing-cards, [data-s3-pricing-card]');
    }

    function onPricingTouchStart(event) {
      if (!event.touches || !event.touches.length) return;
      pricingTouchY = event.touches[0].clientY;
      pricingFlingTouchActive = true;
      if (pricingFlingStopActive) releasePricingFlingStop();
    }

    function onPricingTouchMove(event) {
      if (pricingTransitioning) {
        if (event.cancelable) event.preventDefault();
        pinTerraformScroll();
        return;
      }
      if (autoplayPlaying) {
        onAutoplayLockTouch(event);
        return;
      }
      if (pricingTransitioning && journey === 'pricing') {
        if (event.cancelable) event.preventDefault();
      }
    }

    function onPricingTouchEnd() {
      pricingTouchY = null;
      pricingFlingTouchActive = false;
    }

    function finishAutoplay() {
      autoplayPlaying = false;
      autoplayConsumed = true;
      dismissScrollHint();
      if (autoplayRaf) {
        cancelAnimationFrame(autoplayRaf);
        autoplayRaf = 0;
      }
      paintFrame(maxFrameIndex);
      autoplayLockY = pricingDockY();
      setScrollY(autoplayLockY);
      lastScrollYForDir = autoplayLockY;
      pricingScrollVelPxMs = 0;
      pricingFlingArmed = false;
      unlockAutoplayScroll();
      setScrollY(autoplayLockY);
      enterPricing({ snap: true });
      /* Od teď se scrubuje od konce → dočíst zbytek sekvence od posledního snímku dolů. */
      decodeWindowDir = -1;
      syncDecodeWindow(maxFrameIndex, true);
      prioritizeRemainingFramesFromEnd();
      persistS2bSession();
    }

    function tickAutoplay(ts) {
      if (!autoplayPlaying) return;
      if (!autoplayLastTs) autoplayLastTs = ts;
      var dt = Math.min(64, ts - autoplayLastTs);
      autoplayLastTs = ts;
      /*
       * Rebuffer: přehrávání dojelo načtená data → držet aktuální snímek, dokud není připraven
       * blok AUTOPLAY_REBUFFER_FRAMES dalších snímků (nebo konec). Pokračuje se po blocích,
       * ne snímek po snímku – vizuálně krátká pauza místo trhání.
       */
      if (autoplayRebufferUntil >= 0) {
        var need = Math.min(maxFrameIndex, autoplayRebufferUntil);
        var from = currentFrameIndex + 1;
        if (from <= need && countReadyRunway(from) < (need - from + 1)) {
          if (!autoplayRebufferSince) autoplayRebufferSince = ts;
          if (ts - autoplayRebufferSince > AUTOPLAY_REBUFFER_GIVEUP_MS) {
            /* Síť stojí: nenechat uživatele zamčeného – dokončit na ceník, snímky se dočtou na pozadí. */
            autoplayRebufferUntil = -1;
            autoplayRebufferSince = 0;
            finishAutoplay();
            return;
          }
          autoplayFrameAcc = 0;
          syncAutoplayScrollToFrame();
          autoplayRaf = requestAnimationFrame(tickAutoplay);
          return;
        }
        autoplayRebufferUntil = -1;
        autoplayRebufferSince = 0;
      }
      autoplayFrameAcc += (autoplayFps * dt) / 1000;
      while (autoplayFrameAcc >= 1) {
        autoplayFrameAcc -= 1;
        if (currentFrameIndex >= maxFrameIndex) {
          finishAutoplay();
          return;
        }
        var next = currentFrameIndex + 1;
        if (!images[next] || !images[next].complete) {
          autoplayFrameAcc = 0;
          autoplayRebufferUntil = Math.min(maxFrameIndex, next + AUTOPLAY_REBUFFER_FRAMES - 1);
          boostUpcomingAutoplayFrames(next);
          break;
        }
        if (!images[next].naturalWidth) {
          currentFrameIndex = next;
          continue;
        }
        paintFrame(next);
      }
      syncAutoplayScrollToFrame();
      autoplayRaf = requestAnimationFrame(tickAutoplay);
    }

    function startAutoplay(opts) {
      opts = opts || {};
      if (window.__mojeForceScrollTopUntil && Date.now() < window.__mojeForceScrollTopUntil) return;
      if (autoplayConsumed || autoplayPlaying) return;
      if (isProgrammaticNav() && !pendingAutoplayFromNav && !opts.fromNav) {
        consumeAutoplayWithoutPlay();
        requestTick();
        return;
      }
      if (!totalFrames) {
        autoplayConsumed = true;
        dismissScrollHint();
        enterPricing({ snap: true });
        return;
      }
      if (!images[0] || !images[0].complete || !images[0].naturalWidth) {
        if (loadedCount >= totalFrames) {
          autoplayConsumed = true;
          dismissScrollHint();
          enterPricing({ snap: true });
        }
        return;
      }
      if (!framesReadyForAutoplay()) {
        autoplayWaitingForRunway = true;
        return;
      }
      autoplayWaitingForRunway = false;
      markDefaultSequenceReady();
      journey = 'autoplay';
      dismissScrollHint();
      if (!opts.fromNav) applySectionHeight({ compensate: false });
      autoplayPlaying = true;
      autoplayLastTs = 0;
      autoplayFrameAcc = 0;
      autoplayRebufferUntil = -1;
      autoplayRebufferSince = 0;
      decodeWindowDir = 1;
      syncDecodeWindow(0, true);
      lockAutoplayScroll({ keepY: !!opts.fromNav });
      if (opts.fromNav) {
        pinStartY = getScrollY();
        pinStartCached = pinStartY > 0;
        autoplayLockY = pinStartY;
      }
      paintFrame(0);
      hideLoader();
      warmPricingStageImages();
      autoplayRaf = requestAnimationFrame(tickAutoplay);
    }

    function localScroll() {
      return getScrollY() - pinStartY;
    }

    function nowMs() {
      return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
    }

    function isMobilePricingFlingTarget() {
      if (!isMobileViewport()) return false;
      try {
        if (window.Shopify && window.Shopify.designMode) return false;
      } catch (eDesign) {}
      return true;
    }

    function samplePricingFlingVelocity(y) {
      var ts = nowMs();
      var dt = pricingFlingVelInited ? ts - pricingFlingVelTs : 999;
      var stale = !pricingFlingVelInited || dt >= 140 || dt <= 0;
      if (!stale) {
        pricingScrollVelPxMs = (y - lastScrollYForDir) / dt;
      } else {
        pricingScrollVelPxMs = 0;
        pricingFlingVelInited = true;
      }
      pricingFlingVelTs = ts;
      return stale;
    }

    function killPricingFlingMomentum(lockY) {
      var y = Math.max(0, Math.round(lockY));
      pricingScrollVelPxMs = 0;
      setScrollY(y);
      try {
        if (window.scrollTo) window.scrollTo(0, y);
      } catch (eScrollTo) {}
      requestAnimationFrame(function () {
        setScrollY(y);
        try {
          if (window.scrollTo) window.scrollTo(0, y);
        } catch (eScrollTo2) {}
        requestAnimationFrame(function () {
          setScrollY(y);
        });
      });
    }

    function unfreezeDocumentScrollForPricingFling() {
      if (pricingFlingFreezeRaf) {
        cancelAnimationFrame(pricingFlingFreezeRaf);
        pricingFlingFreezeRaf = 0;
      }
      if (pricingFlingSafetyTimer) {
        clearTimeout(pricingFlingSafetyTimer);
        pricingFlingSafetyTimer = 0;
      }
      if (root) root.classList.remove('moje-s2b--checkpoint-stop');
      var html = document.documentElement;
      html.classList.remove('moje-s2b-checkpoint-scroll-freeze');
      if (!pricingFlingFrozen) return;
      pricingFlingFrozen = false;
      html.style.overflow = pricingFlingPrevHtmlOverflow || '';
      html.style.overscrollBehavior = pricingFlingPrevHtmlOverscroll || '';
      if (document.body) {
        document.body.style.overflow = pricingFlingPrevBodyOverflow || '';
        document.body.style.overscrollBehavior = pricingFlingPrevBodyOverscroll || '';
      }
    }

    function freezeDocumentScrollForPricingFling(lockY) {
      var html = document.documentElement;
      var body = document.body;
      var firstFreeze = !pricingFlingFrozen;
      if (firstFreeze) {
        pricingFlingFrozen = true;
        pricingFlingPrevHtmlOverflow = html.style.overflow;
        pricingFlingPrevBodyOverflow = body ? body.style.overflow : '';
        pricingFlingPrevHtmlOverscroll = html.style.overscrollBehavior;
        pricingFlingPrevBodyOverscroll = body ? body.style.overscrollBehavior : '';
        html.style.overflow = 'hidden';
        html.style.overscrollBehavior = 'none';
        if (body) {
          body.style.overflow = 'hidden';
          body.style.overscrollBehavior = 'none';
        }
        html.classList.add('moje-s2b-checkpoint-scroll-freeze');
        if (root) root.classList.add('moje-s2b--checkpoint-stop');
      }
      if (lockY !== null && Number.isFinite(lockY)) {
        if (firstFreeze) killPricingFlingMomentum(lockY);
        else if (Math.abs(getScrollY() - lockY) > 0.5) setScrollY(lockY);
      }
      if (!pricingFlingFreezeRaf) {
        var pinLoop = function () {
          pricingFlingFreezeRaf = 0;
          if (!pricingFlingFrozen || pricingFlingLockY === null) return;
          if (Math.abs(getScrollY() - pricingFlingLockY) > 0.5) {
            setScrollY(pricingFlingLockY);
          }
          pricingFlingFreezeRaf = requestAnimationFrame(pinLoop);
        };
        pricingFlingFreezeRaf = requestAnimationFrame(pinLoop);
      }
      if (pricingFlingSafetyTimer) clearTimeout(pricingFlingSafetyTimer);
      pricingFlingSafetyTimer = setTimeout(function () {
        pricingFlingSafetyTimer = 0;
        releasePricingFlingStop();
      }, PRICING_FLING_HOLD_MS + 80);
    }

    function releasePricingFlingStop() {
      if (!pricingFlingStopActive && !pricingFlingFrozen) return;
      if (pricingFlingReleaseTimer) {
        clearTimeout(pricingFlingReleaseTimer);
        pricingFlingReleaseTimer = 0;
      }
      var lockY = pricingFlingLockY;
      pricingFlingStopActive = false;
      pricingFlingHoldUntil = 0;
      pricingFlingLockY = null;
      pricingFlingArmed = false;
      unfreezeDocumentScrollForPricingFling();
      if (lockY !== null && Number.isFinite(lockY)) {
        killPricingFlingMomentum(lockY);
        lastScrollYForDir = lockY;
      } else {
        lastScrollYForDir = getScrollY();
      }
      pricingScrollVelPxMs = 0;
    }

    function enforcePricingFlingLock() {
      if (!pricingFlingStopActive || pricingFlingLockY === null) return false;
      if (!pricingFlingFrozen) {
        freezeDocumentScrollForPricingFling(pricingFlingLockY);
      } else if (Math.abs(getScrollY() - pricingFlingLockY) > 0.5) {
        setScrollY(pricingFlingLockY);
      }
      pricingScrollVelPxMs = 0;
      lastScrollYForDir = pricingFlingLockY;
      return true;
    }

    function updatePricingFlingArming(y, vel) {
      var dock = pricingDockY();
      if (!Number.isFinite(dock)) return;
      var leavePad = Math.max(90, getViewportH() * 0.22);
      var settlePad = Math.max(36, getViewportH() * 0.08);
      if (Math.abs(y - dock) > leavePad) {
        pricingFlingArmed = true;
        return;
      }
      if (Math.abs(y - dock) <= settlePad && Math.abs(vel) < PRICING_FLING_VEL_PX_MS * 0.45) {
        pricingFlingArmed = false;
      }
    }

    function engagePricingFlingStop(dockY, opts) {
      opts = opts || {};
      var dock = Math.max(0, Math.round(dockY));
      var liveY = getScrollY();
      var fromBelow = !!opts.fromBelow || journey === 'below' || liveY > dock + 12;
      pricingFlingStopActive = true;
      pricingFlingLockY = dock;
      pricingFlingHoldUntil = Date.now() + PRICING_FLING_HOLD_MS;
      pricingFlingArmed = false;
      pricingScrollVelPxMs = 0;
      cancelPricingCardsExit({ restore: false });
      if (fromBelow) {
        /*
         * Zespodu nesmí enterPricing sahat na výšku sekce (compensate)
         * ani nechat sticky pin. overflow:hidden jinak na iOS na 1 snímek
         * shodí scroll na 0 a problikne začátek stránky.
         * Nejdřív fixed overlay karet, až potom freeze.
         */
        journey = 'pricing';
        atPricing = true;
        pricingLocked = true;
        belowArmed = false;
        suppressPricingRelockUntil = 0;
        pricingSettleUntil = Date.now() + 280;
        pricingUseFixedPin = true;
        if (!pricingVisible) showPricingVisual();
        else if (root) root.classList.add('moje-s2b--pricing-active');
        if (pricingScene) {
          pricingScene.classList.add('moje-s2b__pricing-scene--visible');
          pricingScene.classList.add('moje-s2b__pricing-scene--cards-in');
        }
        applyMistProgress(0);
        setFixedPin(true);
        if (innerEl) void innerEl.offsetHeight;
      } else if (journey !== 'pricing') {
        enterPricing({ snap: false });
      } else {
        pinForJourney();
        if (!pricingVisible || pricingExiting) showPricingVisual();
      }
      dock = Math.max(0, Math.round(pricingDockY()));
      pricingFlingLockY = dock;
      applyMistProgress(0);
      setScrollY(dock);
      if (innerEl) void innerEl.offsetHeight;
      freezeDocumentScrollForPricingFling(dock);
      lastScrollYForDir = dock;
      if (pricingFlingReleaseTimer) clearTimeout(pricingFlingReleaseTimer);
      pricingFlingReleaseTimer = setTimeout(function () {
        pricingFlingReleaseTimer = 0;
        releasePricingFlingStop();
      }, PRICING_FLING_HOLD_MS);
    }

    function maybeCatchPricingFling(yNow, prevY) {
      if (!isMobilePricingFlingTarget()) return false;
      if (enforcePricingFlingLock()) return true;
      if (isProgrammaticNav()) return false;
      if (pricingTransitioning) return false;
      if (pricingFlingTouchActive) {
        updatePricingFlingArming(yNow, pricingScrollVelPxMs);
        return false;
      }
      if (pricingZoneTouchAxis === 'x') return false;
      if (!pricingFlingArmed) {
        updatePricingFlingArming(yNow, pricingScrollVelPxMs);
        return false;
      }

      var dock = Math.round(pricingDockY());
      if (!Number.isFinite(dock) || dock < 8) return false;
      var dy = yNow - prevY;
      var vel = Math.abs(pricingScrollVelPxMs);
      var fast = vel >= PRICING_FLING_VEL_PX_MS || Math.abs(dy) >= PRICING_FLING_JUMP_PX;
      if (!fast) {
        updatePricingFlingArming(yNow, pricingScrollVelPxMs);
        return false;
      }

      var goingDown = dy > 0.4 || (Math.abs(dy) <= 0.4 && pricingScrollVelPxMs > 0);
      var goingUp = dy < -0.4 || (Math.abs(dy) <= 0.4 && pricingScrollVelPxMs < 0);
      var catchPad = Math.max(56, getViewportH() * 0.16);
      var crossed = (prevY < dock && yNow >= dock) || (prevY > dock && yNow <= dock);
      var near = Math.abs(yNow - dock) <= catchPad;
      var towardDock = (goingDown && prevY < dock) || (goingUp && prevY > dock);
      if (!crossed && !(near && towardDock)) {
        updatePricingFlingArming(yNow, pricingScrollVelPxMs);
        return false;
      }

      engagePricingFlingStop(dock, { fromBelow: goingUp || journey === 'below' });
      return true;
    }

    function updateFromScroll() {
      if (pinTerraformScroll()) return;
      if (autoplayPlaying || journey === 'autoplay') {
        if (isProgrammaticNav() && !pendingAutoplayFromNav) {
          consumeAutoplayWithoutPlay();
        } else {
          setScrollY(autoplayLockY);
          lastScrollYForDir = autoplayLockY;
          pricingFlingVelTs = nowMs();
          pricingScrollVelPxMs = 0;
          return;
        }
      }
      if (pricingFlingStopActive && enforcePricingFlingLock()) return;
      var yNow = visualScrollY();
      var prevY = lastScrollYForDir;
      var staleSample = samplePricingFlingVelocity(yNow);
      if (staleSample) {
        lastScrollYForDir = yNow;
        updatePricingFlingArming(yNow, 0);
      } else if (maybeCatchPricingFling(yNow, prevY)) {
        lastScrollYForDir = pricingFlingLockY !== null ? pricingFlingLockY : getScrollY();
        return;
      } else {
        lastScrollYForDir = yNow;
      }
      var local = yNow - pinStartY;
      var seqEnd = Math.max(0, sequencePx);
      var dockLocal = seqEnd + Math.max(0, bufferPx);

      if (!autoplayConsumed) {
        if (window.__mojeForceScrollTopUntil && Date.now() < window.__mojeForceScrollTopUntil) {
          paintFrame(0);
          return;
        }
        if (local >= 0) {
          if (pendingAutoplayFromNav) {
            tryStartPendingAutoplay();
            return;
          }
          if (isProgrammaticNav()) {
            consumeAutoplayWithoutPlay();
          } else if (totalFrames && framesReadyForAutoplay()) {
            startAutoplay();
            return;
          } else if (!totalFrames) {
            autoplayConsumed = true;
            dismissScrollHint();
            enterPricing({ snap: true });
            return;
          } else {
            /* Runway ještě není – po každém načteném snímku přijde requestTick() a autoplay se rozjede sám. */
            autoplayWaitingForRunway = true;
            beginDefaultSequenceLoad();
            paintFrame(0);
            return;
          }
        } else {
          paintFrame(0);
          return;
        }
      }

      if (local < 0) {
        paintFrame(0);
        setFixedPin(false);
        applyMistProgress(0);
        if (pricingVisible) hidePricingVisual();
        return;
      }

      var mist = mistProgressFromLocal(local);

      if (local < seqEnd) {
        if (journey !== 'sequence') enterSequence();
        setFixedPin(true);
        var t = seqEnd <= 0 ? 1 : Math.max(0, Math.min(1, local / seqEnd));
        paintFrame(Math.round(t * maxFrameIndex));
        applyMistProgress(mist);
        if (pricingVisible) {
          if (isProgrammaticNav()) hidePricingVisual();
          else beginPricingCardsExitForSequence();
        }
        return;
      }

      if (local < dockLocal - 0.5) {
        if (journey === 'sequence' || journey === 'buffer') {
          enterPricing({ snap: false });
        } else if (journey !== 'pricing') {
          enterPricing({ snap: false });
        }
        pricingUseFixedPin = true;
        setFixedPin(true);
        paintFrame(maxFrameIndex);
        if (!pricingVisible || pricingExiting) showPricingVisual();
        applyMistProgress(mist);
        queueDockAnchor(local);
        return;
      }

      var dockY = pricingDockY();
      if (yNow <= dockY + 28) {
        if (journey === 'below' && Date.now() < suppressPricingRelockUntil) {
          applyMistProgress(0);
          return;
        }
        if (journey !== 'pricing') enterPricing({ snap: false });
        pinForJourney();
        paintFrame(maxFrameIndex);
        if (!pricingVisible || pricingExiting) showPricingVisual();
        applyMistProgress(0);
        return;
      }

      if (journey !== 'below') enterBelow();
      setFixedPin(false);
      if (!pricingVisible || pricingExiting) showPricingVisual();
      applyMistProgress(0);
    }

    function requestTick() {
      if (rafScheduled) return;
      rafScheduled = true;
      requestAnimationFrame(function () {
        rafScheduled = false;
        updateFromScroll();
        syncScrollHint();
        syncSeqMouseHint();
      });
    }

    /* —— Pricing cards —— */
    function getVideoMapEntry(entry) {
      if (!entry) return { webm: '', mp4: '' };
      if (typeof entry === 'string') return { webm: '', mp4: entry };
      return sanitizeVideoCatalogEntry({ webm: entry.webm || '', mp4: entry.mp4 || '' });
    }

    function getPricingTransitionKey(fromStage, toStage) {
      return String(fromStage) + '-' + String(toStage);
    }

    function getPricingTransitionEntry(fromStage, toStage, packHint) {
      var key = getPricingTransitionKey(fromStage, toStage);
      var maps = pricingVideoMap || {};
      var desktop = maps.desktop || {};
      var mobile = maps.mobile || {};
      var wantWide = packHint === 'desktop' || packHint === 'd' ||
        ((packHint !== 'mobile' && packHint !== 'm') && useWideMediaAssets());
      var entry = wantWide
        ? (desktop[key] || mobile[key])
        : (mobile[key] || desktop[key]);
      return getVideoMapEntry(entry);
    }

    function assignVideoElementSources(video, entry) {
      if (!video) return false;
      var parsed = getVideoMapEntry(entry);
      var nextMp4 = parsed.mp4 || '';
      var nextWebm = parsed.webm || '';
      var curMp4 = '';
      var curWebm = '';
      var sources = video.querySelectorAll('source');
      var i;
      for (i = 0; i < sources.length; i += 1) {
        var type = (sources[i].getAttribute('type') || '').toLowerCase();
        if (type.indexOf('webm') !== -1) curWebm = sources[i].getAttribute('src') || '';
        else curMp4 = sources[i].getAttribute('src') || '';
      }
      if (!curMp4 && !curWebm) curMp4 = video.getAttribute('src') || '';
      if (curMp4 === nextMp4 && curWebm === nextWebm && (nextMp4 || nextWebm)) return false;
      video.innerHTML = '';
      video.removeAttribute('src');
      if (parsed.mp4) {
        var sm = document.createElement('source');
        sm.src = parsed.mp4;
        sm.type = 'video/mp4';
        video.appendChild(sm);
      }
      if (parsed.webm) {
        var sw = document.createElement('source');
        sw.src = parsed.webm;
        sw.type = 'video/webm';
        video.appendChild(sw);
      }
      return true;
    }

    function terraformEntryForKey(key) {
      var parts = String(key || '').split('-');
      return getPricingTransitionEntry(Number(parts[0]), Number(parts[1]));
    }

    function terraformPreferredUrl(key) {
      var parsed = terraformEntryForKey(key);
      return parsed.mp4 || parsed.webm || '';
    }

    function ensureTerraformDock() {
      if (terraformDock && terraformDock.isConnected) {
        if (root && terraformDock.parentNode !== root) root.appendChild(terraformDock);
        return terraformDock;
      }
      terraformDock = document.getElementById('moje-s2b-terraform-dock-' + sectionId);
      if (!terraformDock) {
        terraformDock = document.createElement('div');
        terraformDock.id = 'moje-s2b-terraform-dock-' + sectionId;
        terraformDock.className = 'moje-s2b__terraform-dock';
        terraformDock.setAttribute('aria-hidden', 'true');
      }
      if (root) root.appendChild(terraformDock);
      else if (document.body) document.body.appendChild(terraformDock);
      return terraformDock;
    }

    function createTerraformVideoEl(key) {
      var v = document.createElement('video');
      v.className = 'moje-s2b__pricing-video';
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.preload = 'none';
      v.controls = false;
      v.tabIndex = -1;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('data-tf-key', key);
      return v;
    }

    function getOrCreateTerraformVideo(key) {
      var pack = useWideMediaAssets() ? 'desktop' : 'mobile';
      var live = terraformVideos[key];
      if (live && live.isConnected && live.getAttribute('data-tf-pack') === pack) return live;
      if (live && live.isConnected) return live;
      var dock = ensureTerraformDock();
      var existing = dock.querySelector('video[data-tf-key="' + key + '"]');
      if (!existing && pricingVideoLayer) {
        existing = pricingVideoLayer.querySelector('video[data-tf-key="' + key + '"]');
      }
      if (!existing) existing = createTerraformVideoEl(key);
      if (existing.parentNode !== dock) dock.appendChild(existing);
      terraformVideos[key] = existing;
      return existing;
    }

    function terraformVideoIsReady(video) {
      return !!(video && video.readyState >= 3);
    }

    function bindTerraformSources(video, key, forceLoad) {
      if (!video) return;
      var pack = useWideMediaAssets() ? 'desktop' : 'mobile';
      var entry = terraformEntryForKey(key);
      var url = entry.mp4 || entry.webm || '';
      if (!url) return;
      var packMismatch = video.getAttribute('data-tf-pack') !== pack;
      var changed = assignVideoElementSources(video, entry);
      var alreadyReady = !changed && !packMismatch && video.readyState >= 3;
      video.setAttribute('data-tf-key', key);
      video.setAttribute('data-active-key', key);
      video.setAttribute('data-tf-pack', pack);
      if (alreadyReady && !forceLoad) return;
      if (forceLoad || video === pricingVideo) {
        video.preload = 'auto';
        if (changed || packMismatch || video.readyState < 2) {
          try { video.pause(); } catch (ePauseBind) {}
          try { video.load(); } catch (eLoad) {}
        }
      }
    }

    /*
     * Terraform videa – třístupňově, místo 6–12 <video preload="auto"> najednou:
     *   1) warm (metadata): jen 2 přechody z aktuální karty, preload="metadata" → pár set KB
     *      (moov atom), na iOS/Chrome-mobil funguje (preload="auto" tam prohlížeč stejně clampuje).
     *   2) intent (hover/focus/centrování karty v karuselu): preload="auto" + load() pro 1 video.
     *   3) klik: adoptTerraformVideo() → plné načtení a přehrání.
     * Elementy mimo aktuální dvojici se z docku odstraní (limit dekodérů na iOS).
     */
    function enqueueTerraformWarm(key) {
      var packId = useWideMediaAssets() ? 'd' : 'm';
      var id = packId + ':' + key;
      if (terraformWarmed[id] || terraformWarmQueued[id]) return;
      terraformWarmQueued[id] = true;
      terraformWarmQueue.push({ key: key, packId: packId, id: id });
      pumpTerraformWarm();
    }

    function pumpTerraformWarm() {
      if (terraformWarming) return;
      var job = terraformWarmQueue.shift();
      if (!job) return;
      terraformWarming = true;
      var video;
      if (pricingTransitioning && pricingVideo && pricingVideo.getAttribute('data-tf-key') === job.key) {
        terraformWarmed[job.id] = true;
        terraformWarming = false;
        pumpTerraformWarm();
        return;
      }
      video = getOrCreateTerraformVideo(job.key);
      /* preload nastavit před vložením <source> – výběr zdroje startuje hned při vložení. */
      if (video.getAttribute('data-tf-intent') !== '1' && video.preload !== 'auto') video.preload = 'metadata';
      bindTerraformSources(video, job.key, false);
      if (!video || video.readyState >= 1) {
        terraformWarmed[job.id] = true;
        terraformWarming = false;
        pumpTerraformWarm();
        return;
      }
      var settled = false;
      function done() {
        if (settled) return;
        settled = true;
        terraformWarmed[job.id] = true;
        terraformWarming = false;
        pumpTerraformWarm();
      }
      video.addEventListener('loadedmetadata', done, { once: true });
      video.addEventListener('error', done, { once: true });
      setTimeout(done, 4000);
      if (video.networkState === 0 /* NETWORK_EMPTY */) {
        try { video.load(); } catch (eWarmLoad) {}
      }
    }

    function preloadTerraformKey(key) {
      var url = terraformPreferredUrl(key);
      if (!url) return;
      enqueueTerraformWarm(key);
    }

    /* Klíče přechodů z aktuální karty (max 2). */
    function terraformKeysFromCurrentStage() {
      var from = String(currentPricingStage || 2);
      return TERRAFORM_KEYS.filter(function (key) {
        return key.indexOf(from + '-') === 0;
      });
    }

    /* Odstraní z docku <video> elementy, které nejsou v keepKeys (a nejsou právě přehrávané). */
    function trimTerraformDock(keepKeys) {
      var dock = ensureTerraformDock();
      var vids = dock.querySelectorAll('video');
      var i;
      for (i = 0; i < vids.length; i += 1) {
        var v = vids[i];
        if (v === pricingVideo && pricingTransitioning) continue;
        var key = v.getAttribute('data-tf-key') || '';
        if (keepKeys.indexOf(key) >= 0 && v.getAttribute('data-tf-pack') === (useWideMediaAssets() ? 'desktop' : 'mobile')) continue;
        if (v.getAttribute('data-tf-intent') === '1' && keepKeys.indexOf(key) >= 0) continue;
        try { v.pause(); } catch (ePauseTrim) {}
        v.removeAttribute('src');
        v.innerHTML = '';
        try { v.load(); } catch (eLoadTrim) {}
        if (v.parentNode) v.parentNode.removeChild(v);
        if (v === pricingVideo) pricingVideo = null;
        Object.keys(terraformVideos).forEach(function (k) {
          if (terraformVideos[k] === v) delete terraformVideos[k];
        });
        Object.keys(terraformWarmed).forEach(function (k) {
          if (k.slice(k.indexOf(':') + 1) === key) {
            delete terraformWarmed[k];
            delete terraformWarmQueued[k];
          }
        });
      }
    }

    function startTerraformPreload(force) {
      if (!force && !defaultSequenceFullyReady()) return;
      terraformPreloadStarted = true;
      ensureTerraformDock();
      var placeholder = document.getElementById('moje-s2b-pricing-video-' + sectionId);
      if (placeholder && !placeholder.getAttribute('data-tf-key')) {
        placeholder.setAttribute('hidden', '');
        placeholder.setAttribute('aria-hidden', 'true');
      }
      var keys = terraformKeysFromCurrentStage();
      if (terraformIntentKey && keys.indexOf(terraformIntentKey) < 0) terraformIntentKey = '';
      trimTerraformDock(keys);
      if (isSaveDataEnabled()) return;
      keys.forEach(function (key) {
        preloadTerraformKey(key);
      });
    }

    /* Intent: uživatel míří na kartu → plné načtení jednoho videa (přechod aktuální → cílová). */
    var terraformIntentKey = '';
    function warmTerraformForIntent(targetStage) {
      var target = Number(targetStage);
      if (!Number.isFinite(target) || target === currentPricingStage) return;
      if (journey !== 'pricing' && journey !== 'buffer' && journey !== 'below') return;
      if (pricingTransitioning || isSaveDataEnabled()) return;
      var key = getPricingTransitionKey(currentPricingStage, target);
      if (terraformIntentKey === key) return;
      if (!terraformPreferredUrl(key)) return;
      terraformIntentKey = key;
      var video = getOrCreateTerraformVideo(key);
      video.setAttribute('data-tf-intent', '1');
      bindTerraformSources(video, key, true);
    }

    function bindTerraformIntent() {
      if (!pricingScene) return;
      function stageFromEvent(event) {
        var card = event.target && event.target.closest
          ? event.target.closest('[data-s3-pricing-card], [data-s3-card-trigger]')
          : null;
        if (!card) return NaN;
        return Number(card.getAttribute('data-s3-pricing-card') || card.getAttribute('data-s3-card-trigger'));
      }
      /* Desktop: hover / klávesnicový fokus. */
      pricingScene.addEventListener('pointerover', function (event) {
        if (event.pointerType === 'touch') return;
        var stage = stageFromEvent(event);
        if (Number.isFinite(stage)) warmTerraformForIntent(stage);
      }, { passive: true });
      pricingScene.addEventListener('focusin', function (event) {
        var stage = stageFromEvent(event);
        if (Number.isFinite(stage)) warmTerraformForIntent(stage);
      });
      /* Mobil: dotyk na kartu (v karuselu se centruje, klik následuje až po centrování). */
      pricingScene.addEventListener('touchstart', function (event) {
        var stage = stageFromEvent(event);
        if (Number.isFinite(stage)) warmTerraformForIntent(stage);
      }, { passive: true });
    }

    /* Až po rozjezdu výchozí sekvence (runway) – terraform je P3, nesmí soupeřit se snímky P2. */
    function whenSequenceRunwayReady(cb) {
      if (!totalFrames || autoplayPlaying || autoplayConsumed || defaultSequenceFullyReady()) {
        cb();
        return;
      }
      setTimeout(function () { whenSequenceRunwayReady(cb); }, 500);
    }

    /* Warm metadat až když se ceník blíží do záběru (ne na první gesto kdekoli na stránce). */
    function armTerraformProximityWarm() {
      if (terraformNudgeArmed) return;
      terraformNudgeArmed = true;
      if (!pricingScene || typeof IntersectionObserver !== 'function') return;
      var io = new IntersectionObserver(function (entries) {
        var hit = false;
        var i;
        for (i = 0; i < entries.length; i += 1) if (entries[i].isIntersecting) hit = true;
        if (!hit) return;
        io.disconnect();
        whenSequenceRunwayReady(function () {
          runWhenIdle(function () { startTerraformPreload(true); }, 3000);
        });
      }, { rootMargin: '60% 0px 60% 0px' });
      io.observe(pricingScene);
    }

    function adoptTerraformVideo(key) {
      var video = getOrCreateTerraformVideo(key);
      bindTerraformSources(video, key, true);
      if (pricingVideoLayer && video.parentNode !== pricingVideoLayer) {
        pricingVideoLayer.appendChild(video);
      }
      pricingVideo = video;
      return video;
    }

    function releaseTerraformVideo() {
      if (!pricingVideo) return;
      stopPricingVideoEndWatch();
      try { pricingVideo.pause(); } catch (eP) {}
      try { pricingVideo.currentTime = 0; } catch (eSeek) {}
      pricingVideo.removeAttribute('poster');
      var dock = ensureTerraformDock();
      if (pricingVideo.getAttribute('data-tf-key') && dock && pricingVideo.parentNode !== dock) {
        dock.appendChild(pricingVideo);
      }
    }

    function getMistColorForStage(stage) {
      if (stage === 1) return 'orange';
      if (stage === 3) return 'cyan';
      return 'purple';
    }

    function dispatchChangeMistColor(stage) {
      document.dispatchEvent(new CustomEvent('changeMistColor', {
        detail: { color: getMistColorForStage(stage) }
      }));
    }

    function dispatchPricingPlanChanged(stage) {
      document.dispatchEvent(new CustomEvent('pricingPlanChanged', {
        detail: { plan: stage }
      }));
    }

    function setPricingStage(stage, opts) {
      opts = opts || {};
      currentPricingStage = stage;
      if (!pricingScene) return;
      var bgLayers = pricingScene.querySelectorAll('[data-s3-stage-bg]');
      var pricingCards = pricingScene.querySelectorAll('[data-s3-pricing-card]');
      var stageRgb = { 1: '255, 122, 31', 2: '217, 70, 239', 3: '6, 182, 212' };
      var rgb = stageRgb[stage] || stageRgb[2];
      var i;
      if (root) root.style.setProperty('--s3-current-rgb', rgb);
      pricingScene.style.setProperty('--s3-current-rgb', rgb);
      for (i = 0; i < bgLayers.length; i += 1) {
        bgLayers[i].classList.toggle(
          'moje-s2b__pricing-stage-bg--active',
          bgLayers[i].getAttribute('data-s3-stage-bg') === String(stage)
        );
      }
      for (i = 0; i < pricingCards.length; i += 1) {
        pricingCards[i].classList.toggle(
          'moje-s2b__pricing-card--active',
          pricingCards[i].getAttribute('data-s3-pricing-card') === String(stage)
        );
      }
      collapseAllPricingFeatures(true);
      snapPricingCarouselToStage(stage);
      syncPricingFeaturesOverflow();
      if (!opts.skipSequence && sequenceSwitchReady) {
        switchSequenceTo(stage, { fromEnd: true, silent: true });
      }
      startTerraformPreload();
      persistS2bSession();
    }

    function captureMojeS2bSessionState() {
      return {
        autoplayConsumed: !!autoplayConsumed,
        autoplayPlaying: !!autoplayPlaying,
        pricingLocked: !!pricingLocked,
        pricingVisible: !!pricingVisible,
        journey: journey || 'pre',
        pricingStage: currentPricingStage || 2,
        frameIndex: currentFrameIndex || 0,
        atPricing: !!atPricing
      };
    }

    window.__mojeS2bCaptureSessionState = captureMojeS2bSessionState;

    function persistS2bSession() {
      if (!(window.mojeSessionResume && typeof window.mojeSessionResume.save === 'function')) return;
      if (window.mojeSessionResume.restoring) return;
      var payload = {
        scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
        s2b: captureMojeS2bSessionState()
      };
      if (autoplayConsumed || pricingLocked || journey === 'pricing' || journey === 'below' || journey === 'buffer') {
        payload.introDone = true;
      }
      window.mojeSessionResume.save(payload);
    }

    function applyS2bSessionResume() {
      var api = window.mojeSessionResume;
      var live = api && typeof api.getS2b === 'function' ? api.getS2b() : null;
      var s = live || sessionResumeS2b || null;
      if (!s || typeof s !== 'object') return;
      consumeAutoplayWithoutPlay();
      var stage = s.pricingStage >= 1 && s.pricingStage <= 3 ? s.pricingStage : currentPricingStage || 2;
      setPricingStage(stage, { skipSequence: false });
      if (s.journey === 'below') {
        enterBelow();
      } else if (
        s.pricingLocked ||
        s.journey === 'pricing' ||
        s.journey === 'buffer' ||
        s.atPricing
      ) {
        enterPricing({ snap: true, force: true });
        dispatchChangeMistColor(stage);
        dispatchPricingPlanChanged(stage);
      } else if (s.journey === 'sequence' || s.journey === 'autoplay') {
        var idx = Number(s.frameIndex);
        if (!Number.isFinite(idx)) idx = currentFrameIndex;
        enterSequence();
        paintFrame(Math.max(0, Math.min(maxFrameIndex, idx)));
      }
    }

    function maybeApplyS2bSessionResume() {
      var api = window.mojeSessionResume;
      if (!(api && api.active && sessionResumeS2b)) return;
      applyS2bSessionResume();
    }

    function isPricingMobileCarousel() {
      if (useWideMediaAssets()) return false;
      return !!(pricingCarousel && window.matchMedia && window.matchMedia('(max-width: 989px)').matches);
    }

    function isPricingCarouselInteractable() {
      return !!(
        isPricingMobileCarousel() &&
        pricingCarousel &&
        pricingScene &&
        pricingScene.classList.contains('moje-s2b__pricing-scene--visible') &&
        pricingScene.classList.contains('moje-s2b__pricing-scene--cards-in') &&
        !pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit') &&
        !pricingTransitioning
      );
    }

    function syncPricingTouchCapture() {
      if (!pricingScene) return;
      var interactable = isPricingCarouselInteractable();
      pricingScene.classList.remove('moje-s2b__pricing-scene--touch-capture');
      pricingScene.classList.toggle('moje-s2b__pricing-scene--carousel-loose', interactable);
    }

    function invalidatePricingCarouselCentersCache() {
      pricingCarouselCentersCache = null;
      pricingCarouselCentersCacheW = 0;
    }

    function getPricingCarouselCardCenters() {
      if (!pricingCarousel) return { centers: [], stages: [] };
      var w = pricingCarousel.clientWidth || 0;
      if (
        pricingCarouselCentersCache &&
        pricingCarouselCentersCacheW === w &&
        pricingCarouselCentersCache.centers.length
      ) {
        return pricingCarouselCentersCache;
      }
      var cards = pricingCarousel.querySelectorAll('[data-s3-pricing-card]');
      var centers = [];
      var stages = [];
      var i;
      var stage;
      for (i = 0; i < cards.length; i += 1) {
        stage = parseInt(cards[i].getAttribute('data-s3-pricing-card'), 10);
        if (!stage) continue;
        centers.push(cards[i].offsetLeft + cards[i].offsetWidth / 2);
        stages.push(stage);
      }
      pricingCarouselCentersCache = { centers: centers, stages: stages };
      pricingCarouselCentersCacheW = w;
      return pricingCarouselCentersCache;
    }

    function getPricingCarouselCenteredStage() {
      if (!pricingCarousel || !isPricingMobileCarousel()) return currentPricingStage;
      var pack = getPricingCarouselCardCenters();
      var centers = pack.centers;
      var stages = pack.stages;
      if (!centers.length) return currentPricingStage;
      var center = pricingCarousel.scrollLeft + pricingCarousel.clientWidth / 2;
      var best = currentPricingStage;
      var bestDist = Infinity;
      var i;
      var d;
      for (i = 0; i < centers.length; i += 1) {
        d = Math.abs(center - centers[i]);
        if (d < bestDist) {
          bestDist = d;
          best = stages[i];
        }
      }
      return best;
    }

    function setPricingCarouselSettling(active) {
      if (!pricingScene) return;
      pricingScene.classList.toggle('moje-s2b__pricing-scene--carousel-settling', !!active);
    }

    function flushPricingCarouselDrag() {
      if (pricingCarouselDragRaf) {
        cancelAnimationFrame(pricingCarouselDragRaf);
        pricingCarouselDragRaf = 0;
      }
      if (!pricingCarousel || !pricingCarouselDragPendingDx) {
        pricingCarouselDragPendingDx = 0;
        return;
      }
      pricingCarousel.scrollLeft += pricingCarouselDragPendingDx;
      pricingCarouselDragPendingDx = 0;
    }

    function stopPricingCarouselScrollAnim() {
      if (pricingCarouselScrollAnimRaf) {
        cancelAnimationFrame(pricingCarouselScrollAnimRaf);
        pricingCarouselScrollAnimRaf = null;
      }
      if (pricingCarouselSnapSettleTimer) {
        clearTimeout(pricingCarouselSnapSettleTimer);
        pricingCarouselSnapSettleTimer = null;
      }
    }

    function easeOutCarousel(t) {
      if (t >= 1) return 1;
      if (t <= 0) return 0;
      return 1 - Math.pow(2, -10 * t);
    }

    function animatePricingCarouselScrollTo(target, onComplete) {
      if (!pricingCarousel) return;
      stopPricingCarouselScrollAnim();
      flushPricingCarouselDrag();

      var startPos = pricingCarousel.scrollLeft;
      var delta = target - startPos;
      var absDelta = Math.abs(delta);
      if (absDelta < 1) {
        pricingCarousel.scrollLeft = target;
        pricingCarouselProgrammaticScroll = false;
        syncPricingCarouselMobilePreview();
        syncPricingCarouselHintsEdgeState();
        requestAnimationFrame(function () {
          setPricingCarouselSettling(false);
          if (onComplete) onComplete();
        });
        return;
      }

      pricingCarouselProgrammaticScroll = true;
      setPricingCarouselSettling(true);
      pricingCarouselTouchVelocityPxMs = 0;

      var duration = Math.min(2400, Math.max(1600, 1500 + absDelta * 1.15));
      var startTime = 0;
      var lastPreviewSyncAt = 0;

      function finishAnim() {
        pricingCarousel.scrollLeft = target;
        pricingCarouselProgrammaticScroll = false;
        pricingCarouselScrollAnimRaf = null;
        setPricingCarouselSettling(false);
        requestAnimationFrame(function () {
          syncPricingCarouselMobilePreview();
          syncPricingCarouselHintsEdgeState();
          if (onComplete) onComplete();
        });
      }

      function step(now) {
        if (!pricingCarousel) return;
        if (!startTime) startTime = now;
        var t = Math.min(1, (now - startTime) / duration);
        var eased = easeOutCarousel(t);
        pricingCarousel.scrollLeft = startPos + delta * eased;
        if (now - lastPreviewSyncAt >= 72) {
          lastPreviewSyncAt = now;
          scheduleSyncPricingCarouselMobilePreview({ bgOnly: true });
        }
        if (t < 1) {
          pricingCarouselScrollAnimRaf = requestAnimationFrame(step);
          return;
        }
        finishAnim();
      }

      pricingCarouselScrollAnimRaf = requestAnimationFrame(step);
    }

    function snapPricingCarouselToStage(stage) {
      if (!pricingCarousel || !isPricingMobileCarousel()) return;
      var card = pricingCarousel.querySelector('[data-s3-pricing-card="' + stage + '"]');
      if (!card) return;
      var target = Math.max(0, Math.round(card.offsetLeft + card.offsetWidth / 2 - pricingCarousel.clientWidth / 2));
      if (Math.abs(target - pricingCarousel.scrollLeft) < 1) {
        syncPricingCarouselHintsEdgeState();
        syncPricingCarouselMobilePreview();
        return;
      }
      animatePricingCarouselScrollTo(target);
    }

    function jumpPricingCarouselToStage(stage) {
      if (!pricingCarousel || !isPricingMobileCarousel()) return;
      var card = pricingCarousel.querySelector('[data-s3-pricing-card="' + String(stage) + '"]');
      if (!card) return;
      var target = Math.max(0, Math.round(card.offsetLeft + card.offsetWidth / 2 - pricingCarousel.clientWidth / 2));
      pricingCarouselProgrammaticScroll = true;
      pricingCarousel.scrollLeft = target;
      requestAnimationFrame(function () {
        pricingCarouselProgrammaticScroll = false;
        syncPricingCarouselHintsEdgeState();
        syncPricingCarouselMobilePreview();
      });
    }

    function snapPricingCarouselToActiveCard() {
      if (!pricingCarousel || !isPricingMobileCarousel()) return;
      var active = pricingScene ? pricingScene.querySelector('.moje-s2b__pricing-card--active') : null;
      if (!active) return;
      jumpPricingCarouselToStage(active.getAttribute('data-s3-pricing-card'));
    }

    function scheduleSnapPricingCarouselToActiveCard() {
      if (!isPricingMobileCarousel()) return;
      invalidatePricingCarouselCentersCache();
      snapPricingCarouselToActiveCard();
      requestAnimationFrame(function () {
        snapPricingCarouselToActiveCard();
        requestAnimationFrame(function () {
          snapPricingCarouselToActiveCard();
        });
      });
      setTimeout(function () {
        snapPricingCarouselToActiveCard();
        syncPricingCarouselHintsLayout();
        syncPricingFeaturesOverflow();
      }, 60);
      setTimeout(function () {
        snapPricingCarouselToActiveCard();
        syncPricingFeaturesOverflow();
      }, 220);
    }

    function snapPricingCarouselAfterDrag(totalDx) {
      if (!pricingCarousel) return;
      var cards = pricingCarousel.querySelectorAll('[data-s3-pricing-card]');
      if (!cards.length) return;
      var maxStage = cards.length;
      var startStage = pricingZoneDragStartStage || getPricingCarouselCenteredStage();
      var width = pricingCarousel.clientWidth || 1;
      var threshold = width * PRICING_CAROUSEL_SWIPE_ADVANCE_RATIO;
      var flickDist = width * PRICING_CAROUSEL_FLICK_RATIO;
      var vel = pricingCarouselTouchVelocityPxMs;
      var targetStage;
      if (totalDx <= -threshold || (vel > PRICING_CAROUSEL_FLICK_VEL && totalDx < -flickDist * 0.4)) {
        targetStage = Math.min(maxStage, startStage + 1);
      } else if (totalDx >= threshold || (vel < -PRICING_CAROUSEL_FLICK_VEL && totalDx > flickDist * 0.4)) {
        targetStage = Math.max(1, startStage - 1);
      } else if (Math.abs(vel) > PRICING_CAROUSEL_FLICK_VEL * 1.35) {
        targetStage = vel > 0
          ? Math.min(maxStage, startStage + 1)
          : Math.max(1, startStage - 1);
      } else {
        targetStage = getPricingCarouselCenteredStage();
      }
      snapPricingCarouselToStage(targetStage);
    }

    function drivePricingCarouselByTouch(touchX, event) {
      if (!pricingCarousel || pricingZoneTouchLastX === null) return;
      stopPricingCarouselScrollAnim();
      if (event && event.cancelable) event.preventDefault();
      var now = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
      var dx = pricingZoneTouchLastX - touchX;
      var dt = Math.max(1, now - (pricingCarouselTouchLastTs || now));
      var instantVel = dx / dt;
      pricingCarouselTouchVelocityPxMs = pricingCarouselTouchVelocityPxMs * 0.8 + instantVel * 0.2;
      pricingCarouselTouchLastTs = now;
      pricingZoneTouchLastX = touchX;
      pricingCarouselDragPendingDx += dx * PRICING_CAROUSEL_DRAG_GAIN;
      setPricingCarouselSettling(true);
      if (!pricingCarouselDragRaf) {
        pricingCarouselDragRaf = requestAnimationFrame(function () {
          pricingCarouselDragRaf = 0;
          if (!pricingCarousel || !pricingCarouselDragPendingDx) {
            pricingCarouselDragPendingDx = 0;
            return;
          }
          pricingCarousel.scrollLeft += pricingCarouselDragPendingDx;
          pricingCarouselDragPendingDx = 0;
          scheduleSyncPricingCarouselMobilePreview({ bgOnly: true });
        });
      }
    }

    function clearPricingCarouselPreviewClasses() {
      if (!pricingScene) return;
      var nodes = pricingScene.querySelectorAll('.moje-s2b__pricing-card--carousel-preview');
      var i;
      for (i = 0; i < nodes.length; i += 1) {
        nodes[i].classList.remove('moje-s2b__pricing-card--carousel-preview');
      }
      lastPricingCarouselPreviewStage = null;
    }

    function getPricingCarouselPreviewStage() {
      var centered = getPricingCarouselCenteredStage();
      if (centered === currentPricingStage) return null;
      return centered;
    }

    function notePricingMediaAspect(width, height) {
      if (!width || !height) return;
      pricingMediaAspect = width / height;
    }

    function getPricingCoverExcessPx() {
      var cw = viewportW || window.innerWidth || 390;
      var vh = viewportH || getViewportH() || 844;
      var aspect = pricingMediaAspect;
      var seqImg = sequenceRefImage();
      if (seqImg && seqImg.naturalWidth > seqImg.naturalHeight) {
        aspect = seqImg.naturalWidth / seqImg.naturalHeight;
      }
      var renderedWidth = vh * aspect;
      return Math.max(0, renderedWidth - cw);
    }

    function getPricingCoverObjectPositionX(panX) {
      var excess = getPricingCoverExcessPx();
      if (excess <= 0.5) return '50%';
      var pct = 50 + (panX / excess) * 50;
      pct = Math.max(0, Math.min(100, pct));
      return pct.toFixed(2) + '%';
    }

    function applyPricingBgPanX(panX) {
      if (!pricingScene) return;
      if (isMobileViewport()) {
        pricingScene.style.removeProperty('--moje-s2b-bg-pan-x');
        pricingScene.style.setProperty('--moje-s2b-bg-pan-object-x', '50%');
        return;
      }
      pricingScene.style.setProperty('--moje-s2b-bg-pan-x', panX.toFixed(2) + 'px');
      pricingScene.style.removeProperty('--moje-s2b-bg-pan-object-x');
    }

    function stopPricingBgPanAnimation() {
      if (pricingBgPanAnimRaf) {
        cancelAnimationFrame(pricingBgPanAnimRaf);
        pricingBgPanAnimRaf = null;
      }
    }

    function tickPricingBgPan() {
      pricingBgPanAnimRaf = null;
      var diff = pricingBgPanTarget - pricingBgPanCurrent;
      if (Math.abs(diff) < 0.35) {
        pricingBgPanCurrent = pricingBgPanTarget;
        applyPricingBgPanX(pricingBgPanCurrent);
        return;
      }
      pricingBgPanCurrent += diff * PRICING_BG_PAN_LERP;
      applyPricingBgPanX(pricingBgPanCurrent);
      pricingBgPanAnimRaf = requestAnimationFrame(tickPricingBgPan);
    }

    function queuePricingBgPanTarget(panX) {
      pricingBgPanTarget = panX;
      if (!pricingBgPanAnimRaf) {
        pricingBgPanAnimRaf = requestAnimationFrame(tickPricingBgPan);
      }
    }

    function getPricingBgPanRangePx() {
      return getPricingCoverExcessPx() * 0.5 * PRICING_BG_PAN_FRACTION;
    }

    function getPricingCarouselStageBlend() {
      if (!pricingCarousel) return 2;
      var pack = getPricingCarouselCardCenters();
      var centers = pack.centers;
      var stages = pack.stages;
      if (centers.length < 2) return stages[0] || 2;
      var center = pricingCarousel.scrollLeft + pricingCarousel.clientWidth / 2;
      if (center <= centers[0]) return stages[0];
      if (center >= centers[centers.length - 1]) return stages[stages.length - 1];
      var i;
      for (i = 0; i < centers.length - 1; i += 1) {
        if (center >= centers[i] && center <= centers[i + 1]) {
          var span = centers[i + 1] - centers[i];
          if (span <= 0) return stages[i];
          var t = (center - centers[i]) / span;
          return stages[i] + (stages[i + 1] - stages[i]) * t;
        }
      }
      return 2;
    }

    function syncPricingCarouselBgPan() {
      if (isMobileViewport()) return;
      if (!pricingScene || !isPricingMobileCarousel()) return;
      if (!pricingScene.classList.contains('moje-s2b__pricing-scene--visible')) return;
      if (pricingBgPanLocked) {
        applyPricingBgPanX(pricingBgPanLockedValue);
        return;
      }
      var blend = getPricingCarouselStageBlend();
      var panRange = getPricingBgPanRangePx();
      var normalized = (blend - 2) / 1;
      var panX = normalized * panRange;
      if (pricingTransitioning) {
        applyPricingBgPanX(pricingBgPanCurrent);
        return;
      }
      queuePricingBgPanTarget(panX);
    }

    function resetPricingCarouselBgPan() {
      stopPricingBgPanAnimation();
      pricingBgPanLocked = false;
      pricingBgPanLockedValue = 0;
      pricingBgPanCurrent = 0;
      pricingBgPanTarget = 0;
      if (!pricingScene) return;
      pricingScene.style.removeProperty('--moje-s2b-bg-pan-x');
      pricingScene.style.removeProperty('--moje-s2b-bg-pan-object-x');
      lastDrawnIndex = -1;
      paintFrame(currentFrameIndex);
    }

    function lockPricingBgPanForTransition() {
      if (isMobileViewport() || !isPricingMobileCarousel()) return;
      pricingBgPanLocked = true;
      pricingBgPanLockedValue = pricingBgPanCurrent;
      pricingBgPanTarget = pricingBgPanLockedValue;
      stopPricingBgPanAnimation();
      applyPricingBgPanX(pricingBgPanLockedValue);
    }

    function unlockPricingBgPanForTransition() {
      pricingBgPanLocked = false;
    }

    function syncPricingCarouselMobilePreview(opts) {
      if (!pricingScene || !pricingCarousel) return;
      if (!isPricingMobileCarousel()) {
        clearPricingCarouselPreviewClasses();
        resetPricingCarouselBgPan();
        return;
      }
      if (!pricingScene.classList.contains('moje-s2b__pricing-scene--visible') || pricingTransitioning) {
        clearPricingCarouselPreviewClasses();
        return;
      }
      syncPricingCarouselBgPan();
      var stuckActive = pricingScene.querySelectorAll(
        '.moje-s2b__pricing-card--active.moje-s2b__pricing-card--carousel-preview'
      );
      var si;
      for (si = 0; si < stuckActive.length; si += 1) {
        stuckActive[si].classList.remove('moje-s2b__pricing-card--carousel-preview');
      }
      if (opts && opts.bgOnly) return;
      var previewStage = getPricingCarouselPreviewStage();
      if (previewStage === lastPricingCarouselPreviewStage) return;

      if (lastPricingCarouselPreviewStage) {
        var prevEl = pricingScene.querySelector('[data-s3-pricing-card="' + lastPricingCarouselPreviewStage + '"]');
        if (prevEl) prevEl.classList.remove('moje-s2b__pricing-card--carousel-preview');
      }

      lastPricingCarouselPreviewStage = previewStage;
      if (!previewStage) return;
      var previewEl = pricingScene.querySelector('[data-s3-pricing-card="' + previewStage + '"]');
      if (previewEl && !previewEl.classList.contains('moje-s2b__pricing-card--active')) {
        previewEl.classList.add('moje-s2b__pricing-card--carousel-preview');
      } else {
        lastPricingCarouselPreviewStage = null;
      }
    }

    function scheduleSyncPricingCarouselMobilePreview(opts) {
      if (pricingCarouselPreviewRaf) return;
      var bgOnly = !!(opts && opts.bgOnly);
      pricingCarouselPreviewRaf = requestAnimationFrame(function () {
        pricingCarouselPreviewRaf = null;
        syncPricingCarouselMobilePreview(bgOnly ? { bgOnly: true } : null);
        if (!bgOnly) syncPricingCarouselHintsEdgeState();
      });
    }

    var CAROUSEL_HINT_FIT_MIN_PX = 68;
    var CAROUSEL_HINT_FIT_MAX_PX = 104;
    var CAROUSEL_HINT_SIZE_SCALE = 0.93;

    function sizeForCarouselHintGap(gapPx) {
      if (!Number.isFinite(gapPx) || gapPx <= 0) return CAROUSEL_HINT_FIT_MIN_PX;
      var fitted = gapPx * 0.78 * CAROUSEL_HINT_SIZE_SCALE;
      return Math.min(CAROUSEL_HINT_FIT_MAX_PX, Math.max(CAROUSEL_HINT_FIT_MIN_PX, fitted));
    }

    function getCarouselHintViewportSpan() {
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 390;
      var left = 0;
      var right = viewportWidth;
      if (window.visualViewport) {
        left = window.visualViewport.offsetLeft || 0;
        right = left + window.visualViewport.width;
      }
      return { left: left, right: right, width: right - left };
    }

    function getCarouselHintFixedSideGap(viewportWidth) {
      var cardWidth = Math.min(viewportWidth * 0.78, 340);
      return Math.max(0, (viewportWidth - cardWidth) * 0.5);
    }

    function syncPricingCarouselHintsLayout() {
      if (!isPricingMobileCarousel() || !pricingCarouselWrap) return;
      if (!pricingScene || !pricingScene.classList.contains('moje-s2b__pricing-scene--visible')) return;
      invalidatePricingCarouselCentersCache();

      var hintLeft = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--left');
      var hintRight = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--right');
      if (!hintLeft || !hintRight) return;

      var viewport = getCarouselHintViewportSpan();
      var wrapRect = pricingCarouselWrap.getBoundingClientRect();
      var sideGap = getCarouselHintFixedSideGap(viewport.width);
      var hintSize = sizeForCarouselHintGap(sideGap);
      var gapCenterBias = 0.51;
      var leftCenterViewport = viewport.left + sideGap * gapCenterBias;
      var rightCenterViewport = viewport.right - sideGap * gapCenterBias;
      var leftCenter = leftCenterViewport - wrapRect.left - hintSize * 0.03;
      var rightCenter = rightCenterViewport - wrapRect.left + hintSize * 0.03;
      var cardLeftViewport = viewport.left + sideGap;
      var cardRightViewport = viewport.right - sideGap;
      var leftMin = viewport.left - wrapRect.left + hintSize * 0.36;
      var leftMax = cardLeftViewport - wrapRect.left - hintSize * 0.36;
      var rightMin = cardRightViewport - wrapRect.left + hintSize * 0.36;
      var rightMax = viewport.right - wrapRect.left - hintSize * 0.36;

      if (leftMax > leftMin) leftCenter = Math.min(leftMax, Math.max(leftMin, leftCenter));
      if (rightMax > rightMin) rightCenter = Math.min(rightMax, Math.max(rightMin, rightCenter));

      hintLeft.style.setProperty('--moje-s2b-carousel-hint-left-x', leftCenter.toFixed(2) + 'px');
      hintLeft.style.setProperty('--moje-s2b-carousel-hint-left-size', hintSize.toFixed(2) + 'px');
      hintRight.style.setProperty('--moje-s2b-carousel-hint-right-x', rightCenter.toFixed(2) + 'px');
      hintRight.style.setProperty('--moje-s2b-carousel-hint-right-size', hintSize.toFixed(2) + 'px');
      syncPricingCarouselHintsEdgeState();
    }

    function syncPricingCarouselHintsEdgeState() {
      if (!isPricingMobileCarousel() || !pricingCarouselWrap) return;
      if (!pricingScene || !pricingScene.classList.contains('moje-s2b__pricing-scene--visible')) return;
      var hintLeft = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--left');
      var hintRight = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--right');
      if (!hintLeft || !hintRight) return;
      var stage = getPricingCarouselCenteredStage();
      hintLeft.classList.toggle('moje-s2b__carousel-hint--edge-hidden', stage === 1);
      hintRight.classList.toggle('moje-s2b__carousel-hint--edge-hidden', stage === 3);
    }

    function getPricingCardStageAtPoint(clientX, clientY) {
      if (!pricingCarousel) return null;
      var cards = pricingCarousel.querySelectorAll('[data-s3-pricing-card]');
      var i;
      for (i = 0; i < cards.length; i += 1) {
        var rect = cards[i].getBoundingClientRect();
        if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
          return parseInt(cards[i].getAttribute('data-s3-pricing-card'), 10) || null;
        }
      }
      return null;
    }

    function getPricingFeaturesExpandAtPoint(clientX, clientY) {
      if (!pricingScene || !Number.isFinite(clientX) || !Number.isFinite(clientY)) return null;
      var buttons = pricingScene.querySelectorAll(
        '.moje-s2b__pricing-card--active .moje-s2b__pricing-features-wrap--overflow .moje-s2b__pricing-features-expand'
      );
      var i;
      for (i = 0; i < buttons.length; i += 1) {
        var btn = buttons[i];
        if (btn.hasAttribute('hidden')) continue;
        var r = btn.getBoundingClientRect();
        if (
          clientX >= r.left - 10 &&
          clientX <= r.right + 10 &&
          clientY >= r.top - 10 &&
          clientY <= r.bottom + 10
        ) {
          return btn;
        }
      }
      return null;
    }

    function getPricingCarouselHintAtPoint(clientX, clientY) {
      if (!pricingCarouselWrap || !Number.isFinite(clientX) || !Number.isFinite(clientY)) return null;
      var hintLeft = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--left');
      var hintRight = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--right');
      function hit(el) {
        if (!el || el.classList.contains('moje-s2b__carousel-hint--edge-hidden')) return false;
        var r = el.getBoundingClientRect();
        var pad = 12;
        return (
          clientX >= r.left - pad &&
          clientX <= r.right + pad &&
          clientY >= r.top - pad &&
          clientY <= r.bottom + pad
        );
      }
      if (hit(hintLeft)) return 'left';
      if (hit(hintRight)) return 'right';
      return null;
    }

    function resetPricingZoneTouchState() {
      pricingZoneTouchStartX = null;
      pricingZoneTouchStartY = null;
      pricingZoneTouchLastX = null;
      pricingZoneTouchLastY = null;
      pricingZoneTouchAxis = null;
      pricingZoneTapCardStage = null;
      pricingZoneTapExpandBtn = null;
      pricingZoneTapHintDir = null;
      pricingZoneDragStartStage = null;
    }

    function onPricingOverlayTouchStart(event) {
      if (!isPricingCarouselInteractable()) return;
      if (!event.touches || !event.touches.length) return;
      var touch = event.touches[0];
      pricingZoneTouchStartX = touch.clientX;
      pricingZoneTouchStartY = touch.clientY;
      pricingZoneTouchLastX = touch.clientX;
      pricingZoneTouchLastY = touch.clientY;
      pricingZoneTouchAxis = null;
      pricingZoneTapExpandBtn = getPricingFeaturesExpandAtPoint(touch.clientX, touch.clientY);
      pricingZoneTapHintDir = pricingZoneTapExpandBtn
        ? null
        : getPricingCarouselHintAtPoint(touch.clientX, touch.clientY);
      pricingZoneTapCardStage = (pricingZoneTapExpandBtn || pricingZoneTapHintDir)
        ? null
        : getPricingCardStageAtPoint(touch.clientX, touch.clientY);
      pricingZoneDragStartStage = getPricingCarouselCenteredStage();
      pricingCarouselTouchVelocityPxMs = 0;
      pricingCarouselTouchLastTs =
        typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
    }

    function onPricingOverlayTouchMove(event) {
      if (pricingZoneTouchStartX === null) return;
      if (!event.touches || !event.touches.length) return;
      if (!isPricingCarouselInteractable() && pricingZoneTouchAxis !== 'x') {
        resetPricingZoneTouchState();
        return;
      }
      var touch = event.touches[0];
      var touchX = touch.clientX;
      var touchY = touch.clientY;
      var dx = touchX - pricingZoneTouchStartX;
      var dy = touchY - pricingZoneTouchStartY;

      if (!pricingZoneTouchAxis) {
        if (Math.abs(dx) < PRICING_ZONE_TOUCH_THRESHOLD && Math.abs(dy) < PRICING_ZONE_TOUCH_THRESHOLD) {
          return;
        }
        pricingZoneTouchAxis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        pricingZoneTapCardStage = null;
        pricingZoneTapExpandBtn = null;
        pricingZoneTapHintDir = null;
      }

      if (pricingZoneTouchAxis === 'x') {
        drivePricingCarouselByTouch(touchX, event);
      }
    }

    function onPricingOverlayTouchEnd(event) {
      if (pricingZoneTouchAxis === 'x') {
        flushPricingCarouselDrag();
        scheduleSyncPricingCarouselMobilePreview();
        syncPricingCarouselHintsEdgeState();
        var totalDx = 0;
        if (event && event.changedTouches && event.changedTouches.length && pricingZoneTouchStartX !== null) {
          totalDx = event.changedTouches[0].clientX - pricingZoneTouchStartX;
        }
        snapPricingCarouselAfterDrag(totalDx);
        resetPricingZoneTouchState();
        return;
      }

      setPricingCarouselSettling(false);

      if (
        pricingZoneTouchAxis === null &&
        pricingZoneTouchStartX !== null &&
        event &&
        event.changedTouches &&
        event.changedTouches.length
      ) {
        var endX = event.changedTouches[0].clientX;
        var endY = event.changedTouches[0].clientY;
        var tapped =
          Math.abs(endX - pricingZoneTouchStartX) <= PRICING_ZONE_TAP_SLOP &&
          Math.abs(endY - pricingZoneTouchStartY) <= PRICING_ZONE_TAP_SLOP;
        if (tapped) {
          if (pricingZoneTapExpandBtn) {
            var expandWrap = pricingZoneTapExpandBtn.closest('.moje-s2b__pricing-features-wrap');
            togglePricingFeaturesExpand(expandWrap);
            resetPricingZoneTouchState();
            return;
          }
          if (pricingZoneTapHintDir) {
            var centered = getPricingCarouselCenteredStage();
            var nextStage = pricingZoneTapHintDir === 'left'
              ? Math.max(1, centered - 1)
              : Math.min(3, centered + 1);
            snapPricingCarouselToStage(nextStage);
            resetPricingZoneTouchState();
            return;
          }
          if (pricingZoneTapCardStage) {
            var centeredTap = getPricingCarouselCenteredStage();
            if (pricingZoneTapCardStage !== centeredTap) {
              snapPricingCarouselToStage(pricingZoneTapCardStage);
            } else if (pricingZoneTapCardStage !== currentPricingStage) {
              playPricingTransition(pricingZoneTapCardStage);
            } else {
              clearPricingCarouselPreviewClasses();
              syncPricingCarouselMobilePreview();
            }
          }
        }
      }

      resetPricingZoneTouchState();
    }

    function stageBgImage(stage) {
      if (!pricingScene) return null;
      var wrap = pricingScene.querySelector('[data-s3-stage-bg="' + stage + '"]');
      if (!wrap) return null;
      if (useMobileMediaAssets()) {
        return wrap.querySelector('.moje-s2b__pricing-stage-img--mobile') || wrap.querySelector('img');
      }
      return wrap.querySelector('.moje-s2b__pricing-stage-img--desktop') || wrap.querySelector('img');
    }

    function stageBgImageSrc(stage) {
      var img = stageBgImage(stage);
      if (!img) return '';
      return img.currentSrc || img.getAttribute('src') || '';
    }

    function warmPricingStageImages(opts) {
      if (!pricingScene) return;
      opts = opts || {};
      hydrateStageImagesForViewport();
      var imgs = pricingScene.querySelectorAll('[data-s3-stage-bg] img');
      var defaultOnly = !opts.all && (!defaultSequenceFullyReady() || pendingAutoplayFromNav || autoplayPlaying);
      var i;
      for (i = 0; i < imgs.length; i += 1) {
        var img = imgs[i];
        if (useMobileMediaAssets() && img.classList.contains('moje-s2b__pricing-stage-img--desktop') && stageWrapHasMobileImage(img.closest('[data-s3-stage-bg]'))) continue;
        if (useWideMediaAssets() && img.classList.contains('moje-s2b__pricing-stage-img--mobile')) continue;
        if (!img.getAttribute('src')) continue;
        var isActive = !!(img.closest && img.closest('.moje-s2b__pricing-stage-bg--active'));
        if (defaultOnly && !isActive) continue;
        try { img.loading = 'eager'; } catch (eEager) {}
        try { img.decoding = isActive ? 'sync' : 'async'; } catch (eDec) {}
        if (isActive) {
          try { img.fetchPriority = 'high'; } catch (ePri) {}
        }
        if (typeof img.decode === 'function') {
          img.decode().catch(function () {});
        }
        if (img.naturalWidth && img.naturalHeight) {
          notePricingMediaAspect(img.naturalWidth, img.naturalHeight);
        }
      }
    }

    function whenStageBgReady(stage, cb) {
      hydrateStageImagesForViewport();
      var img = stageBgImage(stage);
      var done = false;
      function once() {
        if (done) return;
        done = true;
        cb();
      }
      if (!img || (img.complete && img.naturalWidth)) {
        once();
        return;
      }
      img.addEventListener('load', once, { once: true });
      img.addEventListener('error', once, { once: true });
      try { img.loading = 'eager'; } catch (eReady) {}
      if (typeof img.decode === 'function') {
        img.decode().then(once).catch(once);
      }
      setTimeout(once, 500);
    }

    function stopPricingVideoEndWatch() {
      if (pricingVideoEndWatchRaf) {
        cancelAnimationFrame(pricingVideoEndWatchRaf);
        pricingVideoEndWatchRaf = 0;
      }
      if (pricingVideo) {
        pricingVideo.onended = null;
        pricingVideo.onerror = null;
      }
    }

    function hidePricingVideoLayerInstant() {
      if (!pricingVideoLayer) return;
      pricingVideoLayer.classList.add('moje-s2b__pricing-video-layer--handoff');
      pricingVideoLayer.classList.remove('moje-s2b__pricing-video-layer--active');
      pricingVideoLayer.setAttribute('aria-hidden', 'true');
    }

    function teardownPricingVideoElement() {
      releaseTerraformVideo();
    }

    function freezePricingVideoLastFrame() {
      if (!pricingVideo) return;
      try {
        var d = pricingVideo.duration;
        if (d && isFinite(d) && d > 0) {
          var freezeAt = Math.max(0, d - PRICING_VIDEO_FREEZE_TAIL_S);
          if (pricingVideo.currentTime < freezeAt) pricingVideo.currentTime = freezeAt;
        }
        pricingVideo.pause();
      } catch (eFreeze) {}
    }

    function armPricingVideoEndWatch(targetStage) {
      stopPricingVideoEndWatch();
      if (!pricingVideo) return;
      function handoff() {
        finishPricingTransition(targetStage, { seamless: true });
      }
      pricingVideo.onended = function () {
        pricingVideo.onended = null;
        handoff();
      };
      pricingVideo.onerror = function () {
        pricingVideo.onerror = null;
        finishPricingTransition(targetStage);
      };
      function tick() {
        pricingVideoEndWatchRaf = 0;
        if (pricingTransitionFinishLock || !pricingTransitioning) return;
        var d = pricingVideo.duration;
        var t = pricingVideo.currentTime;
        if (d && isFinite(d) && t >= d - PRICING_VIDEO_FREEZE_TAIL_S) {
          handoff();
          return;
        }
        pricingVideoEndWatchRaf = requestAnimationFrame(tick);
      }
      pricingVideoEndWatchRaf = requestAnimationFrame(tick);
    }

    function armDestBgUnderVideo(targetStage) {
      if (pricingTransitionFinishLock || !pricingTransitioning) return;
      if (pricingScene) pricingScene.classList.add('moje-s2b__pricing-scene--instant-bg');
      if (currentPricingStage !== targetStage) {
        setPricingStage(targetStage, { skipSequence: true });
      }
    }

    function clearPricingDestCoverTimer() {
      if (pricingDestCoverTimer) {
        clearTimeout(pricingDestCoverTimer);
        pricingDestCoverTimer = 0;
      }
    }

    function finishPricingTransition(targetStage, opts) {
      opts = opts || {};
      if (pricingTransitionFinishLock) return;
      pricingTransitionFinishLock = true;
      detachPricingVideoReadyListeners();
      stopPricingVideoEndWatch();
      clearPricingDestCoverTimer();
      if (pricingTransitionFailTimer) {
        clearTimeout(pricingTransitionFailTimer);
        pricingTransitionFailTimer = null;
      }

      var seamless = !!opts.seamless && !!pricingVideo;
      if (pricingScene) pricingScene.classList.add('moje-s2b__pricing-scene--instant-bg');

      function ensureDestStage() {
        if (currentPricingStage !== targetStage) setPricingStage(targetStage, { skipSequence: true });
      }

      function revealCards() {
        hidePricingVideoLayerInstant();
        if (pricingScene) {
          pricingScene.classList.remove('moje-s2b__pricing-scene--transitioning');
          pricingScene.classList.remove('moje-s2b__pricing-scene--cards-out');
          pricingScene.classList.add('moje-s2b__pricing-scene--cards-in');
        }
        if (root) root.classList.remove('moje-s2b--video-playing');
        pricingTransitioning = false;
        unlockS2bChrome('terraform');
        unlockPricingBgPanForTransition();
        dispatchChangeMistColor(targetStage);
        dispatchPricingPlanChanged(targetStage);
        clearPricingCarouselPreviewClasses();
        try {
          if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
        } catch (eBlur) {}
        syncPricingTouchCapture();
        scheduleSnapPricingCarouselToActiveCard();
        requestAnimationFrame(function () {
          teardownPricingVideoElement();
          /* Nová karta = nové 2 přechody: vyčistit dock (přehrané/staré <video>) a ohřát metadata. */
          runWhenIdle(function () {
            if (!pricingTransitioning) startTerraformPreload(true);
          }, 2500);
          if (pricingVideoLayer) {
            pricingVideoLayer.classList.remove('moje-s2b__pricing-video-layer--handoff');
          }
          if (sequenceSwitchReady) {
            switchSequenceTo(targetStage, { fromEnd: true, silent: true, freezeLayout: true });
          }
          syncPricingCanvasBg();
          var destLast = images[maxFrameIndex];
          if (destLast && !(destLast.complete && destLast.naturalWidth)) {
            destLast.addEventListener('load', function onDestLast() {
              if (currentPricingStage === targetStage && pricingVisible) syncPricingCanvasBg();
            }, { once: true });
          }
          requestAnimationFrame(function () {
            if (pricingScene) pricingScene.classList.remove('moje-s2b__pricing-scene--instant-bg');
            syncPricingCanvasBg();
            syncPricingFeaturesOverflow();
            syncPricingCarouselHintsLayout();
          });
        });
      }

      if (seamless) {
        freezePricingVideoLastFrame();
        ensureDestStage();
        var videoAlreadyEnded = !!(pricingVideo && pricingVideo.ended);
        whenStageBgReady(targetStage, function () {
          if (videoAlreadyEnded) {
            revealCards();
            return;
          }
          requestAnimationFrame(function () {
            requestAnimationFrame(revealCards);
          });
        });
        return;
      }

      ensureDestStage();
      teardownPricingVideoElement();
      revealCards();
    }

    function playPricingTransition(targetStage) {
      if (!pricingScene || pricingTransitioning || targetStage === currentPricingStage) return;
      if (journey !== 'pricing' && journey !== 'buffer' && journey !== 'below') return;
      syncWideMediaClass();
      pricingTransitioning = true;
      pricingTransitionFinishLock = false;
      pinPricingForTerraform();
      lockS2bChrome('terraform');
      var key = getPricingTransitionKey(currentPricingStage, targetStage);
      var parsed = getPricingTransitionEntry(currentPricingStage, targetStage);
      var videoUrl = parsed.mp4 || parsed.webm || '';
      adoptTerraformVideo(key);
      maybeStartDeferredS2bMedia(true);
      preloadSequenceStage(targetStage, { fromEnd: true, boost: 120 });

      if (root) root.classList.add('moje-s2b--video-playing');
      pricingScene.classList.add('moje-s2b__pricing-scene--transitioning');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-in');
      pricingScene.classList.add('moje-s2b__pricing-scene--cards-out');
      lockPricingBgPanForTransition();
      collapseAllPricingFeatures(true);
      syncPricingTouchCapture();
      warmPricingStageImages();
      if (isMobileViewport()) {
        /* theme after video */
      } else {
        dispatchChangeMistColor(targetStage);
        dispatchPricingPlanChanged(targetStage);
      }

      if (!videoUrl || !pricingVideo || !pricingVideoLayer) {
        setTimeout(function () { finishPricingTransition(targetStage); }, 650);
        return;
      }

      var exitMinDone = false;
      var mediaReady = false;
      var revealStarted = false;
      var destBgArmed = false;
      var currentPoster = stageBgImageSrc(currentPricingStage);
      if (currentPoster) pricingVideo.setAttribute('poster', currentPoster);
      else pricingVideo.removeAttribute('poster');

      function armDestWhenCovered() {
        if (destBgArmed || pricingTransitionFinishLock) return;
        destBgArmed = true;
        armDestBgUnderVideo(targetStage);
      }

      function tryRevealAndPlay() {
        if (revealStarted || !exitMinDone || !mediaReady) return;
        revealStarted = true;
        if (pricingVideoLayer) {
          pricingVideoLayer.classList.remove('moje-s2b__pricing-video-layer--handoff');
          pricingVideoLayer.classList.add('moje-s2b__pricing-video-layer--active');
          pricingVideoLayer.setAttribute('aria-hidden', 'false');
        }
        try { pricingVideo.currentTime = 0; } catch (eSeek) {}
        armPricingVideoEndWatch(targetStage);
        var playPromise = pricingVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () { finishPricingTransition(targetStage); });
        }
        /* Cílový obrázek až pod plně zakryté video — jinak problikne planeta nové karty. */
        clearPricingDestCoverTimer();
        pricingDestCoverTimer = setTimeout(function () {
          pricingDestCoverTimer = 0;
          armDestWhenCovered();
        }, 320);
      }

      setTimeout(function () {
        exitMinDone = true;
        tryRevealAndPlay();
      }, PRICING_CARDS_EXIT_MIN_MS);

      function onMediaReady() {
        if (pricingVideo.readyState < 2) return;
        mediaReady = true;
        tryRevealAndPlay();
      }

      pricingVideo.addEventListener('loadeddata', onMediaReady);
      pricingVideo.addEventListener('canplay', onMediaReady);
      pricingVideo.addEventListener('canplaythrough', onMediaReady);
      detachPricingVideoReadyListeners = function () {
        pricingVideo.removeEventListener('loadeddata', onMediaReady);
        pricingVideo.removeEventListener('canplay', onMediaReady);
        pricingVideo.removeEventListener('canplaythrough', onMediaReady);
      };

      pricingTransitionFailTimer = setTimeout(function () {
        pricingTransitionFailTimer = null;
        if (!revealStarted) finishPricingTransition(targetStage);
      }, 14000);

      pricingVideo.setAttribute('data-active-key', key);
      onMediaReady();
    }

    function syncPricingFeaturesWrapOverflow(wrap) {
      if (!wrap) return;
      var list = wrap.querySelector('.moje-s2b__pricing-features');
      var btn = wrap.querySelector('.moje-s2b__pricing-features-expand');
      if (!list) return;
      var expanded = wrap.classList.contains('moje-s2b__pricing-features-wrap--expanded');
      var overflow;
      if (expanded) {
        var collapsedH = Number(wrap.getAttribute('data-collapsed-h') || 0);
        overflow = collapsedH > 0
          ? list.scrollHeight > collapsedH + 2
          : true;
      } else {
        overflow = list.scrollHeight > list.clientHeight + 2;
      }
      wrap.classList.toggle('moje-s2b__pricing-features-wrap--overflow', overflow);
      if (btn) {
        if (overflow) btn.removeAttribute('hidden');
        else btn.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.setAttribute(
          'aria-label',
          expanded ? 'Skrýt seznam výhod' : 'Zobrazit celý seznam výhod'
        );
      }
      if (!overflow && expanded) {
        setPricingFeaturesExpanded(wrap, false);
      }
    }

    function syncPricingFeaturesOverflow() {
      if (!pricingScene) return;
      var wraps = pricingScene.querySelectorAll('.moje-s2b__pricing-features-wrap');
      var i;
      for (i = 0; i < wraps.length; i += 1) {
        syncPricingFeaturesWrapOverflow(wraps[i]);
      }
    }

    function resetPricingFeaturesCardLayout(card, wrap) {
      if (card) {
        card.classList.remove('moje-s2b__pricing-card--features-expanded');
        card.style.removeProperty('--moje-s2b-card-base-h');
        card.style.removeProperty('--moje-s2b-card-expand-extra');
        card.removeAttribute('data-features-base-h');
        card.removeAttribute('data-features-extra');
      }
      if (wrap) {
        wrap.classList.remove('moje-s2b__pricing-features-wrap--expanded');
        wrap.removeAttribute('data-collapsed-h');
        var list = wrap.querySelector('.moje-s2b__pricing-features');
        if (list) {
          list.style.maxHeight = '';
          list.style.overflow = '';
        }
      }
    }

    function setPricingFeaturesExpanded(wrap, expand) {
      if (!wrap) return;
      var list = wrap.querySelector('.moje-s2b__pricing-features');
      var btn = wrap.querySelector('.moje-s2b__pricing-features-expand');
      var card = wrap.closest('.moje-s2b__pricing-card');
      if (!list || !card) return;

      if (expand) {
        if (wrap.classList.contains('moje-s2b__pricing-features-wrap--expanded')) return;

        var baseH = Math.round(card.getBoundingClientRect().height);
        var collapsedListH = list.clientHeight;
        var fullListH = list.scrollHeight;
        var extra = Math.max(0, Math.ceil(fullListH - collapsedListH));
        if (extra < 2) {
          syncPricingFeaturesWrapOverflow(wrap);
          return;
        }

        list.style.maxHeight = '';
        list.style.overflow = 'visible';
        card.setAttribute('data-features-base-h', String(baseH));
        card.setAttribute('data-features-extra', String(extra));
        wrap.setAttribute('data-collapsed-h', String(collapsedListH));
        card.style.setProperty('--moje-s2b-card-base-h', baseH + 'px');
        card.style.setProperty('--moje-s2b-card-expand-extra', extra + 'px');
        wrap.classList.add('moje-s2b__pricing-features-wrap--expanded');
        card.classList.add('moje-s2b__pricing-card--features-expanded');
        if (btn) {
          btn.setAttribute('aria-expanded', 'true');
          btn.setAttribute('aria-label', 'Skrýt seznam výhod');
        }
        return;
      }

      resetPricingFeaturesCardLayout(card, wrap);
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Zobrazit celý seznam výhod');
      }
    }

    function togglePricingFeaturesExpand(wrap) {
      if (!wrap) return;
      setPricingFeaturesExpanded(
        wrap,
        !wrap.classList.contains('moje-s2b__pricing-features-wrap--expanded')
      );
    }

    function isFeaturesListInternallyScrolling(list, deltaY) {
      if (!list) return false;
      var wrap = list.closest('.moje-s2b__pricing-features-wrap');
      if (!wrap || !wrap.classList.contains('moje-s2b__pricing-features-wrap--expanded')) return false;
      if (list.scrollHeight <= list.clientHeight + 1) return false;
      if (deltaY < 0 && list.scrollTop <= 0) return false;
      if (deltaY > 0 && list.scrollTop + list.clientHeight >= list.scrollHeight - 1) return false;
      return true;
    }

    function bindPricingFeaturesWheelPassThrough() {
      if (!pricingScene) return;
      pricingScene.addEventListener('wheel', function (event) {
        var list = event.target && event.target.closest
          ? event.target.closest('.moje-s2b__pricing-features')
          : null;
        if (!list) return;
        if (isFeaturesListInternallyScrolling(list, event.deltaY)) {
          event.stopPropagation();
        }
      }, { capture: true, passive: false });
    }

    function collapseAllPricingFeatures(instant) {
      if (!pricingScene) return;
      var wraps = pricingScene.querySelectorAll('.moje-s2b__pricing-features-wrap--expanded');
      var i;
      for (i = 0; i < wraps.length; i += 1) setPricingFeaturesExpanded(wraps[i], false);
      if (instant) syncPricingFeaturesOverflow();
    }

    function bindPricingFeaturesExpand() {
      if (!pricingScene || pricingFeaturesExpandBound) return;
      pricingFeaturesExpandBound = true;
      pricingScene.addEventListener('click', function (event) {
        var btn = event.target && event.target.closest
          ? event.target.closest('.moje-s2b__pricing-features-expand')
          : null;
        if (!btn || !pricingScene.contains(btn)) return;
        event.preventDefault();
        event.stopPropagation();
        var wrap = btn.closest('.moje-s2b__pricing-features-wrap');
        togglePricingFeaturesExpand(wrap);
      });
    }

    function bindPricingCardClicks() {
      if (!pricingScene) return;
      pricingScene.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('.moje-s2b__pricing-features-expand')) {
          return;
        }
        if (event.target && event.target.closest && event.target.closest('.moje-s2b__carousel-hint')) {
          return;
        }
        var trigger = event.target && event.target.closest
          ? event.target.closest('[data-s3-card-trigger], [data-s3-pricing-card]')
          : null;
        if (!trigger || !pricingScene.contains(trigger)) return;
        var targetStage = Number(
          trigger.getAttribute('data-s3-card-trigger') || trigger.getAttribute('data-s3-pricing-card')
        );
        if (!Number.isFinite(targetStage)) return;
        if (isPricingMobileCarousel() && getPricingCarouselCenteredStage() !== targetStage) {
          event.preventDefault();
          snapPricingCarouselToStage(targetStage);
          return;
        }
        event.preventDefault();
        playPricingTransition(targetStage);
      });
    }

    function bindPricingCarouselTouch() {
      if (!pricingScene || pricingCarouselScrollBound) return;
      pricingCarouselScrollBound = true;

      if (pricingTouchOverlay) {
        var overlayPointerId = null;
        function pointerAsTouchEvent(event) {
          var point = { clientX: event.clientX, clientY: event.clientY };
          return {
            touches: [point],
            changedTouches: [point],
            cancelable: event.cancelable,
            preventDefault: function () {
              if (event.cancelable) event.preventDefault();
            }
          };
        }
        pricingTouchOverlay.addEventListener('touchstart', function (event) {
          if (overlayPointerId !== null) return;
          onPricingOverlayTouchStart(event);
        }, { passive: true });
        pricingTouchOverlay.addEventListener('touchmove', function (event) {
          if (overlayPointerId !== null) return;
          onPricingOverlayTouchMove(event);
        }, { passive: false });
        pricingTouchOverlay.addEventListener('touchend', function (event) {
          if (overlayPointerId !== null) return;
          onPricingOverlayTouchEnd(event);
        }, { passive: true });
        pricingTouchOverlay.addEventListener('touchcancel', function (event) {
          if (overlayPointerId !== null) return;
          onPricingOverlayTouchEnd(event);
        }, { passive: true });

        pricingTouchOverlay.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'touch') return;
          if (overlayPointerId !== null) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          overlayPointerId = event.pointerId;
          try { pricingTouchOverlay.setPointerCapture(event.pointerId); } catch (eCap) {}
          onPricingOverlayTouchStart(pointerAsTouchEvent(event));
        });
        pricingTouchOverlay.addEventListener('pointermove', function (event) {
          if (event.pointerType === 'touch') return;
          if (overlayPointerId !== event.pointerId) return;
          onPricingOverlayTouchMove(pointerAsTouchEvent(event));
        });
        function onOverlayPointerUp(event) {
          if (event.pointerType === 'touch') return;
          if (overlayPointerId !== event.pointerId) return;
          overlayPointerId = null;
          onPricingOverlayTouchEnd(pointerAsTouchEvent(event));
        }
        pricingTouchOverlay.addEventListener('pointerup', onOverlayPointerUp);
        pricingTouchOverlay.addEventListener('pointercancel', onOverlayPointerUp);
      }

      bindPricingFeaturesExpand();

      if (pricingCarousel) {
        pricingCarousel.addEventListener(
          'scroll',
          function () {
            if (pricingCarouselProgrammaticScroll) return;
            scheduleSyncPricingCarouselMobilePreview();
          },
          { passive: true }
        );
      }

      function onPricingCarouselViewportChange() {
        if (pricingZoneTouchAxis === 'x') {
          invalidatePricingCarouselCentersCache();
          return;
        }
        var keepPeekStage = null;
        if (isPricingMobileCarousel() && pricingVisible) {
          keepPeekStage = getPricingCarouselCenteredStage();
        }
        invalidatePricingCarouselCentersCache();
        syncPricingTouchCapture();
        if (isPricingMobileCarousel() && pricingVisible) {
          syncPricingCarouselHintsLayout();
          jumpPricingCarouselToStage(keepPeekStage || currentPricingStage);
          syncPricingFeaturesOverflow();
        } else {
          clearPricingCarouselPreviewClasses();
          resetPricingCarouselBgPan();
          if (pricingVisible) {
            requestAnimationFrame(function () {
              syncPricingFeaturesOverflow();
            });
          }
        }
      }

      window.addEventListener('resize', onPricingCarouselViewportChange, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', onPricingCarouselViewportChange, { passive: true });
      }

      syncPricingTouchCapture();
    }

    if (pricingScene) {
      pricingScene.addEventListener('transitionend', onPricingSceneTransitionEnd);
    }

    bindPricingFeaturesExpand();
    bindPricingFeaturesWheelPassThrough();
    bindPricingCardClicks();
    bindPricingCarouselTouch();
    var bootStage =
      sessionResumeS2b && sessionResumeS2b.pricingStage >= 1 && sessionResumeS2b.pricingStage <= 3
        ? sessionResumeS2b.pricingStage
        : 2;
    setPricingStage(bootStage, { skipSequence: true });
    maybeApplyS2bSessionResume();
    if (bootStage !== 2 && window.mojeSessionResume && (window.mojeSessionResume.active || window.mojeSessionResume.restoring)) {
      dispatchChangeMistColor(bootStage);
      dispatchPricingPlanChanged(bootStage);
    }

    window.addEventListener('scroll', function () {
      if (pricingTransitioning) {
        pinTerraformScroll();
        return;
      }
      if (pendingAutoplayFromNav) {
        tryStartPendingAutoplay();
        if (autoplayPlaying) return;
      }
      if (autoplayPlaying) {
        onAutoplayLockScroll();
        return;
      }
      if (pricingFlingStopActive) {
        enforcePricingFlingLock();
        return;
      }
      requestTick();
      queueDockAnchor(localScroll());
    }, { passive: true });
    window.addEventListener('scrollend', function () {
      if (!pendingAutoplayFromNav) return;
      pendingAutoplayScrollEnded = true;
      tryStartPendingAutoplay();
    }, { passive: true });

    window.addEventListener('wheel', onPricingWheel, { passive: false });
    window.addEventListener('touchstart', onPricingTouchStart, { passive: true });
    window.addEventListener('touchmove', onPricingTouchMove, { passive: false });
    window.addEventListener('touchend', onPricingTouchEnd, { passive: true });
    window.addEventListener('touchcancel', onPricingTouchEnd, { passive: true });

    /*
     * Reálná rotace (mobil ↔ šířka): až TEĎ se začne stahovat druhý pack – od aktuálního snímku,
     * ne od začátku. Než dorazí, na plátně zůstane aktuální snímek starého packu v cover ořezu
     * (žádné černé plátno).
     */
    function reloadSequencePackIfNeeded() {
      var nextStore = getSequenceStore(activeSequenceStage);
      if (nextStore.images === images) return false;
      var progress = maxFrameIndex > 0 ? currentFrameIndex / maxFrameIndex : 0;
      var prevImg = null;
      var k;
      for (k = Math.min(maxFrameIndex, currentFrameIndex); k >= 0; k -= 1) {
        if (images[k] && images[k].complete && images[k].naturalWidth) {
          prevImg = images[k];
          break;
        }
      }
      bindSequenceState(activeSequenceStage);
      lastDrawnIndex = -1;
      currentFrameIndex = Math.max(0, Math.min(maxFrameIndex, Math.round(progress * maxFrameIndex)));
      var fromEnd = currentFrameIndex > (maxFrameIndex * 0.5);
      loadAllFrames({ fromEnd: fromEnd });
      /* Nejdřív okolí aktuálního snímku, pak zbytek v pořadí od začátku / od konce. */
      var st = getSequenceStore(activeSequenceStage);
      var lo = Math.max(0, currentFrameIndex - 6);
      var hi = Math.min(maxFrameIndex, currentFrameIndex + 24);
      for (k = lo; k <= hi; k += 1) enqueueFrameLoad(st, k, 260 - Math.abs(k - currentFrameIndex));
      pumpSeqLoadQueue();
      if (prevImg && !frameCanPaint(currentFrameIndex)) {
        resizeCanvas();
        drawCover(prevImg, null);
      }
      return true;
    }

    function applyMediaPackForViewport() {
      var wasWide = !!(root && root.classList.contains('moje-s2b--wide-media'));
      syncWideMediaClass();
      var isWide = !!(root && root.classList.contains('moje-s2b--wide-media'));
      pricingMediaAspect = useWideMediaAssets() ? 16 / 9 : 9 / 16;
      var packId = useWideMediaAssets() ? 'd' : 'm';
      if (packId !== lastMediaPackId) {
        lastMediaPackId = packId;
        DECODE_AHEAD = isMobileViewport() ? 12 : 24;
        startTerraformPreload(true);
        reloadSequencePackIfNeeded();
      }
      applyAdaptiveDomImages();
      warmPricingStageImages();
      if (typeof syncPricingTouchCapture === 'function') syncPricingTouchCapture();
      if (typeof clearPricingCarouselPreviewClasses === 'function') clearPricingCarouselPreviewClasses();
      if (!isPricingMobileCarousel() && typeof resetPricingCarouselBgPan === 'function') {
        resetPricingCarouselBgPan();
      }
      if (pricingVisible) {
        requestAnimationFrame(function () {
          if (wasWide !== isWide) collapseAllPricingFeatures(true);
          else syncPricingFeaturesOverflow();
        });
      }
    }

    function onViewportChange() {
      syncWideMediaClass();
      updateMetrics({
        refreshPinStart: true,
        force: Date.now() >= ignoreMetricsUntil
      });
      resizeCanvas();
      pricingMediaAspect = useWideMediaAssets() ? 16 / 9 : 9 / 16;
      applyAdaptiveDomImages();
      warmPricingStageImages();
      lastDrawnIndex = -1;
      paintFrame(currentFrameIndex);
      syncIntroLayout();
      applySectionHeight();
      requestTick();
      if (mediaPackSyncTimer) clearTimeout(mediaPackSyncTimer);
      mediaPackSyncTimer = setTimeout(function () {
        mediaPackSyncTimer = 0;
        applyMediaPackForViewport();
        lastDrawnIndex = -1;
        paintFrame(currentFrameIndex);
        syncIntroLayout();
        applySectionHeight();
        requestTick();
      }, 120);
    }

    window.addEventListener('resize', onViewportChange, { passive: true });
    window.addEventListener('orientationchange', function () {
      syncWideMediaClass();
      setTimeout(onViewportChange, 280);
    }, { passive: true });
    try {
      var oriMq = window.matchMedia('(orientation: landscape)');
      var onOriMq = function () {
        syncWideMediaClass();
        onViewportChange();
      };
      if (oriMq && typeof oriMq.addEventListener === 'function') oriMq.addEventListener('change', onOriMq);
      else if (oriMq && typeof oriMq.addListener === 'function') oriMq.addListener(onOriMq);
    } catch (eOriMq) {}

    document.addEventListener('shopify:section:load', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== sectionId) return;
      updateMetrics({ refreshPinStart: true });
      requestTick();
    });

    document.addEventListener('shopify:section:unload', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== sectionId) return;
      unlockAutoplayScroll();
      if (scrollHintEl && scrollHintEl.parentNode) {
        scrollHintEl.parentNode.removeChild(scrollHintEl);
      }
      if (seqMouseEl && seqMouseEl.parentNode) {
        seqMouseEl.parentNode.removeChild(seqMouseEl);
      }
    });

    updateMetrics({ refreshPinStart: true });
    resizeCanvas();
    bindSequenceState(currentPricingStage || 2);
    syncIntroPhase();
    syncWideMediaClass();
    holdPipelineForDefaultSequence();
    armTerraformProximityWarm();
    bindTerraformIntent();
    sequenceSwitchReady = true;
    function startDefaultSequenceAfterHero() {
      window.__mojeLaserHeroReady = true;
      beginDefaultSequenceLoad();
    }
    if (window.__mojeLaserHeroReady || !document.querySelector('.laser-section-wrapper')) {
      beginDefaultSequenceLoad();
    } else {
      document.addEventListener('moje:laser-intro-finished', startDefaultSequenceAfterHero, { once: true });
      setTimeout(startDefaultSequenceAfterHero, 10000);
    }
    requestTick();

    bindActiveIntroLoad();
    mountScrollHint();
    syncScrollHint();
    syncSeqMouseHint();

    /* Návrat na tab: cache prohlížeče mohla dekódy uvolnit → znovu nahřát okno kolem aktuálního snímku. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden || document.visibilityState === 'hidden') {
        resetDecodeWindow();
        return;
      }
      syncDecodeWindow(currentFrameIndex, true);
    });

    if (typeof IntersectionObserver === 'function') {
      var vis = new IntersectionObserver(function (entries) {
        var i;
        for (i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting) {
            holdPipelineForDefaultSequence();
            beginDefaultSequenceLoad();
            requestTick();
          }
        }
        syncScrollHint();
        syncSeqMouseHint();
      }, { rootMargin: '240px 0px 240px 0px' });
      vis.observe(root);
    }

    window.__mojeS2bWantsIntroAutoplay = function () {
      return !autoplayConsumed && !autoplayPlaying;
    };

    window.__mojeS2bPauseRangeY = function () {
      try {
        refreshPinStart(true);
        return {
          start: bufferStartY(),
          end: pricingDockY()
        };
      } catch (ePauseY) {
        return { start: 0, end: 0 };
      }
    };

    window.__mojeS2bSequenceRangeY = function () {
      try {
        refreshPinStart(true);
        return {
          start: pinStartY,
          end: sequenceEndY()
        };
      } catch (eSeqY) {
        return { start: 0, end: 0 };
      }
    };

    window.__mojeS2bPricingScrollY = function () {
      try {
        refreshPinStart(true);
        return pricingDockY();
      } catch (ePriceY) {
        return 0;
      }
    };

    function getScrollYForCheckpointTarget(target) {
      refreshPinStart(true);
      if (!(pinStartY > 8)) return null;
      if (target === 'start' || target === 'sequence') return pinStartY;
      return pricingDockY();
    }

    function beginExternalScroll(durationMs) {
      var ms = Math.max(5200, Number(durationMs) || 5200);
      consumeAutoplayWithoutPlay();
      markProgrammaticNav(ms + 400);
      hideLoader();
      return ms;
    }

    function finishExternalCheckpoint(target) {
      consumeAutoplayWithoutPlay();
      refreshPinStart(true);
      var y = getScrollYForCheckpointTarget(target || 'pricing');
      if (Number.isFinite(y) && y > 8) {
        setScrollY(y);
        lastScrollYForDir = y;
      }
      if (journey === 'pricing' && pricingVisible) {
        applyMistProgress(0);
        markProgrammaticNav(480);
        return;
      }
      enterPricing({ snap: true });
      markProgrammaticNav(480);
    }

    function handleExternalCheckpointNavigation(detail) {
      var target = (detail && detail.target) || 'pricing';
      var endY = getScrollYForCheckpointTarget(target);
      var duration = Math.max(5200, Number(detail && detail.duration) || 5200);
      consumeAutoplayWithoutPlay();
      markProgrammaticNav(duration + 400);
      if (!Number.isFinite(endY) || endY <= 8) return;
      skipAutoplayForProgrammaticScroll(endY, { smooth: false, duration: duration });
    }

    function markS2bNavReady() {
      if (root) root.setAttribute('data-s2b-nav-ready', '1');
      window.__mojeS2bScrollApi = {
        sectionId: sectionId,
        getScrollYForCheckpoint: getScrollYForCheckpointTarget,
        beginExternalScroll: beginExternalScroll,
        finishCheckpoint: finishExternalCheckpoint,
        consumeAutoplay: consumeAutoplayWithoutPlay,
        wantsIntroAutoplay: function () {
          return !autoplayConsumed && !autoplayPlaying;
        },
        navigate: handleExternalCheckpointNavigation
      };
      try {
        document.dispatchEvent(new CustomEvent('moje:s2b-nav-ready', { detail: { sectionId: sectionId } }));
      } catch (eNavReady) {}
    }

    markS2bNavReady();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden || document.visibilityState === 'hidden') {
        persistS2bSession();
        return;
      }
      lastDrawnIndex = -1;
      requestTick();
      if (pricingLocked || journey === 'pricing') {
        showPricingVisual();
        scheduleSnapPricingCarouselToActiveCard();
      }
    });
    document.addEventListener('moje:session-soft-resume', function () {
      lastDrawnIndex = -1;
      requestTick();
      if (pricingLocked || journey === 'pricing') {
        showPricingVisual();
        scheduleSnapPricingCarouselToActiveCard();
      }
    });
    document.addEventListener('moje:session-resume-scrolled', function () {
      setTimeout(maybeApplyS2bSessionResume, 40);
      setTimeout(maybeApplyS2bSessionResume, 350);
    });
    if (window.mojeSessionResume && window.mojeSessionResume.active) {
      setTimeout(maybeApplyS2bSessionResume, 60);
      setTimeout(maybeApplyS2bSessionResume, 400);
      setTimeout(maybeApplyS2bSessionResume, 1000);
    }

    document.addEventListener('moje:programmatic-scroll', function (evt) {
      var y = evt && evt.detail ? evt.detail.y : NaN;
      var smooth = !(evt && evt.detail && evt.detail.smooth === false);
      var duration = evt && evt.detail ? evt.detail.duration : undefined;
      var playAutoplay = !!(evt && evt.detail && evt.detail.playAutoplay);
      skipAutoplayForProgrammaticScroll(y, {
        smooth: smooth,
        duration: duration,
        playAutoplay: playAutoplay
      });
    });
  }

  function bootMojeS2bSections() {
    var nodes = document.querySelectorAll('script[type="application/json"][id^="moje-s2b-config-"]');
    var i;
    for (i = 0; i < nodes.length; i += 1) {
      initMojeS2bSection(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMojeS2bSections);
  } else {
    bootMojeS2bSections();
  }
})();
